export const lang = {
  common: {
    play: 'खेलो',
    viewMore: 'अधिक देखें',
    currency: 'मुद्रा',
    fail: 'विफल',
    success: 'सफलता',
    downLoad: 'डाउनलोड',
    next: 'अगला',
    finish: 'समाप्त',
    cancel: 'रद्द करें',
    login: 'लॉगिन',
    ok: 'ठीक है',
    errorPrompt: 'एक त्रुटि हुई है। कृपया पुन: प्रयास करें या हमारे समर्थन से संपर्क करें।',
    submit: 'जमा करें',
    joinin: 'अब शामिल हों',
    search: 'खोज'
  },
  betActivity: {
    todayBet: 'आज की आज की सट्टा राशि',
    estimatedReward: 'अनुमानित इनाम',
    distributingTomorrow: '(कल वितरण कर रहा हूँ)',
    yesterdayReward: 'कल का इनाम',
    cashReward: 'नकद पुरस्कार',
    rules: 'नियम',
    history: 'इतिहास',
    date: 'तारीख',
    bettingAmount: 'सट्टा राशि',
    reward: 'इनाम',
    noDataAvailable: 'कोई डेटा मौजूद नहीं',
    activityNotStartYetMessageContent: 'गतिविधि अभी शुरू नहीं हुई है',
    activityNotStartYetMessageTitle: 'क्षमा मांगना',
    confirmButtonText: 'ठीक है'
  },
  betActivityWeekly: {
    BetThisWeek: 'बेटिंग दिस वीक',
    estimatedReward: 'अनुमानित पुरस्कार',
    distributingNextWeek: '(अगले सप्ताह का वितरण)',
    RewardOfLastWeek: 'पिछले सप्ताह का पुरस्कार',
    cashReward: 'टाटा आईपीएल 2023',
    rules: 'नियम',
    history: 'इतिहास',
    week: 'सप्ताह',
    bettingAmount: 'सट्टेबाजी की राशि',
    reward: 'इनाम',
    noDataAvailable: 'कोई डेटा उपलब्ध नहीं',
    joinNow: 'अभी शामिल हों',
    play: 'खेलो ',
    activityNotStartYetMessageContent: 'गतिविधि अभी शुरू नहीं हुई',
    activityNotStartYetMessageTitle: 'क्षमा करें',
    confirmButtonText: 'ठीक है'
  },
  betActivityRegularly: {
    cashbackRewards: 'रिबेट',
    slogan: 'कैशबैक पुरस्कार अर्जित करने के लिए दांव लगाएं। जितना अधिक आप शर्त लगाते हैं, उतना अधिक आप कमाते हैं',
    rewardsAvailable: 'उपलब्ध इनाम',
    totalReceived: 'कुल इनाम प्राप्त हुए',
    claimNow: 'अभी प्राप्त करें',
    playNow: 'अभी खेलें',
    rules: 'नियम',
    details: 'विवरण',
    totalRewards: 'कुल पुरस्कार',
    totalBet: 'कुल दांव',
    games: 'खेल',
    bet: 'बेट',
    rewards: 'पुरस्कार',
    records: 'रिकॉर्ड',
    Success: 'सफलता',
    claimResultSuccess: 'इनाम का दावा किया जा चुका है। और अधिक पाने के लिए अभी बेट लगाएं!',
    claimResultFailed: 'कोई इनाम उपलब्ध नहीं है.अधिक पाने के लिए अभी शर्त लगाएं!',
    claimResultNotReached: '*छूट हर दिन 12:00 बजे के बाद जारी की जाएगी.',
    cancel: 'रद्द करें',
    noDataAvailable: 'कोई डेटा उपलब्ध नहीं',
    receive: 'पाना'
  },
  WelfareDeposit: {
    title1: 'सीमित समय जमा बोनस',
    title2: 'तक ',
    title3: ' अतिरिक्त मुफ़्त पैसा',
    discount1: 'आपके पास उपयोग के लिए अभी भी छूट उपलब्ध है।',
    discount2: 'समाप्त होने से पहले इसे बर्बाद न करें।',
    deposit: 'जमा',
    cancel: 'रद्द करें'
  },
  RewardTypes: {
    Name1: 'इनवाइट रिवॉर्ड्स',
    Description1: 'साइन-अप और 3x प्ले',
    Name2: 'जमा पुरस्कार',
    Description2: 'जमा राशि का 5%',
    Name3: 'जमा पुरस्कार',
    Description3: '10K जमा',
    Name5: 'इनवाइट रिवॉर्ड्स',
    Description5: 'मित्र साइन अप और जमा',
    Name6: 'जमा पुरस्कार',
    Description6: 'मित्र जमा',
    Name7: 'बेटिंग रिवार्ड्स',
    Description7: 'मित्र 500 से अधिक की शर्त लगा रहा है',
    Name8: 'एजेंट पुरस्कार',
    Description8: 'जमा',
    Name9: 'एजेंट पुरस्कार',
    Description9: 'शर्त'
  },
  gameCatetory: {
    LiveCasino: 'लाइव कैसीनो',
    SlotGames: 'स्लॉट खेल',
    Lottery: 'लॉटरी',
    FishingGames: 'फिशिंग गेम्स',
    SportsGames: 'स्पोर्ट्सगेम्स',
    DOWN: 'डाउन',
    Card: 'कार्ड',
    MostPopular: 'सबसे लोकप्रिय'
  },
  menu: {
    Home: 'होम',
    Games: 'खेल',
    Promotion: 'प्रचार',
    FAQ: 'अक्सर पूछे जाने वाले प्रश्न',
    Deposit: 'जमा',
    Withdraw: 'निकासी',
    Account: 'खाता',
    Edit: 'जानकारी संपादित करें',
    History: 'इतिहास',
    Message: 'संदेश',
    Support: 'समर्थन',
    Terms: 'नियम और शर्तें',
    Privacy: 'गोपनीयता नीति',
    Responsible: 'जिम्मेदार जुआ',
    Affiliate: 'संबद्ध',
    Login: 'लॉगिन',
    Logout: 'लॉग आउट',
    AboutUs: 'हमारे बारे में',
    News: 'समाचार',
    Kyc: 'केवाईसी नीति',
    Language: 'भाषा',
    BackToHome: 'वापस घर'
  },
  footer: {
    Home: 'होम',
    Events: 'इवेंट्स',
    Promotion: 'प्रचार',
    Deposit: 'जमा',
    Withdraw: 'वापस लेना',
    Support: 'समर्थन',
    Agent: 'एजेंट',
    Affiliate: 'संबद्ध'
  },
  rule: {
    Deposit: 'जमा',
    Play: 'खेलो',
    OK: 'ठीक है',
    CollectNow: 'अभी लीजिए',
    Invite: 'आमंत्रित लिंक',
    Go: 'जाना'
  },
  label: {
    POPULAR: 'सर्वाधिक लोकप्रिय',
    CASINO: 'लाइव कैसीनो',
    LOTTERY: 'लॉटरी',
    CARD: 'कार्ड',
    FISHING: 'फिशिंग गेम्स',
    SLOTS: 'स्लॉट्स',
    hot: 'लोकप्रिय',
    live: 'लाइव डीलर्स',
    lottery: 'लाइव डीलर्स',
    card: 'कार्ड',
    crash: 'क्रैश',
    fishing: 'फिशिंग',
    slots: 'स्लॉट्स',
    sports: 'खेल',
    casino: 'लाइव कैसीनो'
  },
  affiliate: {
    rank: 'रैंक',
    rules: 'नियम',
    share: ' हिस्सा बाँट',
    welcomeMessage: 'गेम खेलने और बड़ी जीत के लिए मेरे साथ बेताजय में शामिल हों! %0A %0A 1. PGEBet ऐप डाउनलोड करने के लिए लिंक पर क्लिक करें: {downloadURL} %0A 2. साइन अप करने के लिए कोड {shareCode} का उपयोग करें। %0A 3. पाएं ₹177 %2B ₹20 एक्सक्लूसिव फ्री कैश %26 ₹2500 तक का पहला डिपॉजिट बोनस। %0A %0A रमी, तीन पत्ती, लाइव कैसीनो, क्रिकेट, स्लॉट आपके खेलने का इंतजार कर रहे हैं!',
    confirmButtonText: 'ठीक है',
    activityNotStartYetMessageTitle: 'नोटिस',
    activityNotStartYetMessageContent: 'प्रचार जल्द ही शुरू होगा।',
    activityEndedMessageTitle: 'नोटिस',
    activityEndedMessageContent: 'प्रचार समाप्त हो गया है और पुरस्कार 48 घंटों के भीतर जारी किया जाएगा।'
  },
  promotion: {
    All: 'सभी',
    Expired: 'पर समाप्त करें',
    GamePromotion: 'खेल का प्रचार',
    Jili: 'Jili',
    Daily: 'दैनिक',
    FreeCash: 'व्यापार करने के लिए पैसा',
    Deposit: 'जमा',
    Betting: 'शर्त',
    Affiliate: 'संबद्ध',
    rules: 'नियम',
    title1: '100% जमा बोनस',
    desc1_1: 'अपनी जमा राशि पर 100% बोनस प्राप्त करें!',
    desc1_2: '<div style="text-align: डिस्प्ले: ब्लॉक; चौड़ाई: 100%">40X दांव लगाना</div>>',
    desc1_3: '<div style="text-align: center;  डिस्प्ले: ब्लॉक; चौड़ाई: 100%">केवल एक बार उपयोग | कोई जमा सीमा नहीं</div>',
    title2: '#वर्तमान माह ऊपरी# पागलपन',
    desc2_1: 'वर्तमान माह सामान्य# में शीर्ष 3 सबसे बड़े दैनिक विजेताओं के लिए प्रत्येक ₹2.5 मिलियन#',
    desc2_2: 'मौजूदा महीने की #अंतिम तारीख को तत्काल भुगतान किया गया#',
    title3: 'दिवाली 10-दिन का बोनस',
    desc3_1: 'हैप्पी दिवाली 2021',
    desc3_2: '150% बोनस आपके द्वारा 4 नवंबर से 17 नवंबर तक किए गए प्रत्येक डिपॉजिट के लिए',
    title4: 'आमंत्रित करें और ₹ कमाएँ',
    desc4_1: '①<div style="margin-left: 20px;flex: 1;text-align: left;">साइन अप करने और खेलने के लिए प्रत्येक मित्र को आमंत्रित करने के लिए तत्काल ₹10 प्राप्त करें।</div>',
    desc4_2: '②<div style="margin-left: 20px;flex: 1;text-align: left;">अपने दोस्त की हर जमा राशि का 5% पाएं और अगर उसकी कुल जमा राशि ₹10,000 से अधिक है तो ₹500 और पाएं .</div>',
    desc4_3: '③<div style="margin-left: 20px;flex: 1;text-align: left;">कुल इनाम ₹100 मिलियन तक!</div>>',
    title5: '10 बड़े विजेताओं का महीना',
    desc5_1: 'प्रमोशन पीरियड के दौरान, सबसे अधिक जीतने वाले शीर्ष 10 खिलाड़ी नकद पुरस्कार में 10 मिलियन रुपये से अधिक साझा करने में सक्षम होंगे!',
    title6: 'ऑनलाइन रहें और नकद जीतें',
    desc6_1: '100 रुपये जीतने के लिए लगातार 7 दिनों तक हर दिन 1 घंटे से अधिक PGEBet ऐप पर रहें।',
    promotionDuration: 'पदोन्नति अवधि:',
    duration1: '1 महीना',
    title7: 'स्पोर्ट्स 2023 प्रमोशन',
    desc7_1: 'अपने 150% जमा बोनस का उपयोग करें!',
    desc7_2: 'फुटबॉल और क्रिकेट सहित सभी खेलों पर कोई जमा सीमा नहीं!',
    title8: 'क्रिसमस हॉलिडे स्पेशल',
    desc8_1: 'दिसंबर के लिए अपना PGE उपहार प्राप्त करें!',
    desc8_2: 'दिसंबर में डिपॉजिट पर 150% बोनस मिलेगा। क्रिसमस की रात समाप्त होती है।',
    button_text8: 'भी जमा करें',
    button_nav8: 'जमा',
    title9: 'वीआईपी क्लब बोनस',
    desc9_1: 'वीआईपी क्लब में शामिल हों और प्रत्येक जमा राशि पर बोनस प्राप्त करें!',
    desc9_2: 'वीआईपी सदस्यों के लिए 100% बोनस',
    desc9_3: 'सदस्यों के लिए 150% बोनस',
    button_text9: 'वीआईपी क्लब में शामिल हों',
    button_nav9: 'वीआईपी'
  },
  notice: {
    title1: 'ब्लैकजैक - 21 का एक मजेदार खेल',
    subTitle1: 'आज बड़ी रकम जीतें!',
    text1_1: 'हर मिनट तेज़ गेम खेले गए। खेलना आसान है और सभी बोनस प्रचारों का उपयोग किया जा सकता है।',
    title2: 'बैकार्ट - खेलना इतना आसान!',
    subTitle2: 'बैंकर या खिलाड़ी पर दाव',
    text2_1: 'त्वरित खेल और सभी बोनस प्रचारों का उपयोग किया जा सकता है।',
    title3: 'रूले - बहुत मनोरंजक!',
    subTitle3: 'खेलने में आसान और दुनिया भर में खेला जाता है।',
    text3_1: 'यदि गेंद आपके नंबर पर गिरती है तो आप अपनी बाजी से 35 गुना जीत जाते हैं!',
    title4: 'स्पोर्ट्स बेटिंग 24/7',
    subTitle4: 'अपना दांव बेच भी सकते हैं\'। अधिक जानने के लिए खेलें!\n',
    text4_1: 'दुनिया भर में क्रिकेट, सॉकर और खेल शामिल हैं।',
    title5: 'Roulette Tutorial',
    subTitle5: 'यह वीडियो देखें और खेलना सीखें। आसान और मजेदार।',
    text5_1: 'यदि गेंद आपके नंबर पर गिरती है तो आप अपनी बाजी 35 गुना जीत जाते हैं!',
    titleAndar: 'अंदर बहार प्रतियोगिता',
    subTitleAndar: 'अंदर बहार लाइव खेलें और ₹1 मिलियन मासिक पुरस्कार जीतें!',
    textAndar_1: 'प्रतियोगिता 1 मार्च 2022 को शुरू होगी! बने रहें!',
    buttonAndar: 'मेरी रैंकिंग',
    titleBlackjack: 'ब्लैकजैक ट्यूटोरियल',
    subTitleBlackjack: 'दुनिया में सबसे लोकप्रिय कैसीनो खेलों में से एक।',
    textBlackjack: 'बस डीलर को हरा दें और आप जीत गए! सीखने में आसान और खेलने में मजेदार।'
  },
  winner: {
    justWon: 'बस जीत गया',
    playing: 'खेलना',
    live: 'लाइव',
    players: 'खिलाड़ी'
  },
  login: {
    login: 'लॉग इन करें',
    tooOften: 'कृपया {seconds} सेकण्ड के बाद फिर कोशिश करें',
    register: 'रजिस्टर',
    recover: 'पासवर्ड पुनर्प्राप्त करें',
    reset: 'पासवर्ड रीसेट करें',
    birthday: 'जन्मदिन',
    email: 'ईमेल',
    password: 'पासवर्ड',
    continue: 'या जारी रखें',
    forget: 'पासवर्ड भूल जाओ',
    username: 'उपयोगकर्ता नाम',
    Username: 'उपयोगकर्ता नाम',
    invalid: 'अमान्य मोबाइल नंबर',
    depositCur: 'जमा मुद्रा',
    Recover: 'पुनर्प्राप्त करें',
    Reset: 'रीसेट',
    Submit: 'सबमिट करें',
    mobileNumber: 'मोबाइल नंबर',
    inviteCode: 'आमंत्रण कोड (वैकल्पिक)',
    snsPrompt1: 'कोड भेज दिया गया है',
    snsPrompt2: 'कृपया लॉगिन करने के लिए कोड दर्ज करें।',
    incorrectCode: 'गलत कोड',
    resendCode: 'पुनः भेजें कोड',
    abnormalPrompt1: 'असामान्य गतिविधियों के कारण आपका खाता निलंबित कर दिया गया है। कृपया संपर्क करें',
    abnormalPrompt2: 'या',
    abnormalPrompt3: 'लाइव सपोर्ट',
    abnormalPrompt4: 'यदि आपके कोई प्रश्न हैं।',
    codeExpired: 'कोड समाप्त हो गया है',
    invalidCode: 'अवैध SNSCode',
    newPassword: 'नया पासवर्ड',
    couponCode: 'कूपन कोड (वैकल्पिक)',
    slogan: '₹{amount} अभी प्राप्त करें!',
    attention1: 'भारत की नंबर 1 ऑनलाइन बेटिंग साइट।',
    attention2: 'तत्काल उपहार और अन्य बोनस के लिए अभी लॉग इन करें।',
    toast10002: 'खाते उल्लंघन. लॉगिन निषेध'
  },
  message: {
    readAll: 'सब पढ़ें',
    emailActivate: 'ईमेल सक्रिय करते समय त्रुटि होती है',
    inputEmail: 'कृपया ईमेल दर्ज करें',
    inputPassword: 'कृपया पासवर्ड दर्ज करें',
    inputUsername: 'कृपया उपयोगकर्ता नाम दर्ज करें',
    inputValid: 'कृपया वैध ईमेल पता दर्ज करें',
    passwordMust: 'पासवर्ड 8-18 बिट का होना चाहिए और इसमें संख्या, अक्षर और विशेष वर्ण शामिल होना चाहिए',
    notRegister: 'यह ईमेल पंजीकृत नहीं है',
    notCorrect: 'पासवर्ड सही नहीं है',
    registerSuccess: 'सफलतापूर्वक पंजीकरण करें',
    usernameExit: 'उपयोगकर्ता नाम अस्तित्व में है',
    emailExit: 'ईमेल मौजूद है',
    mobileExit: 'मोबाइल मौजूद था',
    accountSuspended: 'असामान्य गतिविधियों के कारण आपका खाता निलंबित कर दिया गया है। कृपया support@PGEBet.com पर संपर्क करें',
    registerFail: 'असफल। कृपया पुनः प्रयास करें या support@PGEBet.com से संपर्क करें',
    claimSuccess: 'बधाई!आपको',
    claimCash: 'नकद मिले हैं',
    cannotClaimed: 'क्षमा करें, पुरस्कार बार-बार प्राप्त नहीं किए जा सकते।',
    claimed: 'दावा किया',
    MessageDetail: 'संदेश विवरण'
  },
  active: {
    emailActive: 'ईमेल सक्रिय',
    activating: 'अपना ईमेल सक्रिय करना'
  },
  account: {
    outLink: 'IFSC कोड खोजें >>',
    totalBalance: 'कुल शेष',
    cash: 'नकद',
    safe: 'सुरक्षित',
    safeWallet: 'सुरक्षित वॉलेट',
    extra: 'अतिरिक्त',
    deposit: 'जमा',
    transfer: 'स्थानांतरण',
    transferTo: 'स्थानांतरण को',
    safeBalance: 'सुरक्षित संतुलन',
    deposited: 'जमा किया',
    withdrew: 'वापस ले लिया',
    safeOnlyForDeposit: 'सुरक्षित सुविधा केवल जमा ग्राहकों के लिए उपलब्ध है',
    inputAmount: 'इनपुट राशि स्थानांतरित करने के लिए',
    giftAmount: 'उपहार राशि',
    transferExceedLimit: 'स्थानांतरण राशि सीमा से अधिक है: ',
    transferSuccess: 'स्थानांतरण सफल',
    transferFail: 'स्थानांतरण विफल',
    transferError: 'स्थानांतरण त्रुटि',
    betThenWithdraw: 'बेट {bet} वापस लेना <span style="color: #D0D6D9;font-size: 18px;font-weight: bold">{withdraw}</span>',
    withdraw: 'निकासी',
    affiliate: 'संबद्ध',
    bonus: 'बोनस',
    completedBonus: 'पूर्ण बोनस',
    claim: 'दावा',
    invite: 'आमंत्रित लिंक',
    copy: 'कॉपी लिंक',
    copyCode: 'कॉपी कोड',
    cashBalance: 'कैश बैलेंस',
    apply: 'प्राप्त करें',
    depositBonus: 'जमा बोनस',
    agree: 'मैं नियमों और शर्तों से सहमत हूं',
    submit: 'सबमिट करें',
    amount: 'राशि',
    cardInvalid: 'अमान्य।<br>कृपया अपडेट करें।',
    selectAmount: 'कृपया एक राशि चुनें',
    withdrawalRules: 'निकासी नियम',
    withdrawalRuleList:
      '<div style="margin: 12px 0">1. प्रति दिन 5 निकासी तक;</div>' +
      '<div style="margin: 12px 0">2.निकासी शुल्क:</div>' +
      '<div style="margin: 12px 0">&nbsp;&nbsp;① प्रति दिन पहले दो निकासी के लिए 0 निकासी शुल्क;</div>' +
      '<div style="margin: 12px 0">&nbsp;&nbsp;② दो निकासी के बाद, यदि राशि INR 5,000 या उससे कम है, तो INR 250 का शुल्क लिया जाएगा;</div>' +
      '<div style="margin: 12px 0">&nbsp;&nbsp;③ दो निकासी के बाद, यदि राशि INR 5,000 से अधिक है तो 18% शुल्क लिया जाएगा </div>' +
      '<div style="margin: 12px 0">3.जमा राशि को कम से कम 1 बार रोल ओवर किया जाना चाहिए। उदाहरण के लिए, यदि आप INR 500 जमा करते हैं और INR 250 के दो दांव लगाते हैं, तो आपकी अधिकतम निकासी योग्य राशि INR 500 होगी।</div>',
    withdrawalRuleListB:
      '<div style="margin: 12px 0">1. प्रति दिन 5 निकासी तक;</div>' +
      '<div style="margin: 12px 0">2.निकासी शुल्क:</div>' +
      '<div style="margin: 12px 0">①5000 भारतीय रूपीयों के नीचे मात्रों के लिए कोई निकाल फीड नहीं</div>' +
      '<div style="margin: 12px 0">②तीन निकालने के बाद, यदि राशि 5,000 भारतीय रुपये से अधिक है, तो 11% शुल्क लिया जाएगा।</div>' +
      '<div style="margin: 12px 0">3.जमा राशि को कम से कम 1 बार रोल ओवर किया जाना चाहिए। उदाहरण के लिए, यदि आप INR 500 जमा करते हैं और INR 250 के दो दांव लगाते हैं, तो आपकी अधिकतम निकासी योग्य राशि INR 500 होगी।</div>',
    withdrawalRuleListC:
      '<div style="margin: 12px 0">1. प्रति दिन 5 निकासी तक।' +
      '<div style="margin: 12px 0">2. निकासी शुल्क नहीं!' +
      '<div style="margin: 12px 0">3. जमा राशि को कम से कम 1 बार रोल ओवर किया जाना चाहिए। उदाहरण के लिए, यदि आप INR 500 जमा करते हैं और INR 250 के दो दांव लगाते हैं, तो आपकी अधिकतम निकासी योग्य राशि INR 500 होगी।',
    withdrawalRuleListD:
      '<div style="margin: 12px 0">1. प्रति दिन 5 निकासी तक।' +
      '<div style="margin: 12px 0">2. निकासी शुल्क नहीं!' +
      '<div style="margin: 12px 0">3. कृपया अनुरोध में हटाने की निवेदनों को जमा करें, जैसे कि नया निवेदनों को सिर्फ पिछली निवेदन स्वीकार के बाद दिया' +
      '<div style="margin: 12px 0">4. जमा राशि को कम से कम 1 बार रोल ओवर किया जाना चाहिए। उदाहरण के लिए, यदि आप INR 500 जमा करते हैं और INR 250 के दो दांव लगाते हैं, तो आपकी अधिकतम निकासी योग्य राशि INR 500 होगी',
    wallet: 'मेरा बटुआ',
    accountName: 'खाता नाम',
    accountNo: 'खाता संख्या',
    IFSC: 'बैंक कोड (IFSC कोड)',
    check: 'चेक एग्रीमेंट',
    outRange: 'अमान्य राशि, सीमा से बाहर',
    notEnough: 'पर्याप्त शेष राशि उपलब्ध नहीं',
    copySuccess: 'कॉपी सक्सेस',
    gateway: 'गेटवे',
    withdrawableBalance: 'निकासी योग्य शेष राशि',
    notWithdrawable: 'निकासी योग्य नहीं है',
    yourID: 'आपकी आईडी',
    upload: 'अपलोड करें',
    view: 'देखें',
    set: 'परिवर्तन',
    bankAccount: 'बैंक खाता',
    rules: 'नियम',
    myRewards: 'मेरे पुरस्कार',
    friends: 'दोस्त',
    total: 'कुल',
    rewards: 'पुरस्कार',
    stepsToEarn: 'कमाने के लिए कदम',
    noRewardSharePrompt: 'अभी तक कोई पुरस्कार नहीं? अभी अपना कमीशन अर्जित करने के लिए नीचे दिए गए लिंक को साझा करें!',
    joined: 'शामिल हुए',
    inviteRewards: 'इनवाइट रिवॉर्ड्स',
    depositRewards: 'जमा पुरस्कार',
    lastPlayed: 'आखिरी बार खेला गया',
    lastDeposit: 'अंतिम जमा',
    whatsapp: 'व्हाट्सएप',
    selectDepositAmount: 'कृपया डिपॉजिट राशि चुनें',
    selectUPIChannel: 'कृपया UPI चैनल चुनें',
    needLogin: 'कृपया पहले लॉगिन करें',
    promptToSetID: 'कृपया वापस लेने से पहले अपना आईडी सेट करें',
    promptToSubmitID: 'कृपया वापस लेने से पहले अपनी आईडी सबमिट करें',
    promptToSubmitBankAccount: 'कृपया निकासी से पहले अपना बैंक खाता जमा करें',
    selectWithdrawAmount: 'कृपया निकासी राशि का चयन करें',
    withdrawSetup: {
      personalInfo: 'व्यक्तिगत जानकारी',
      idDocument: 'आईडी दस्तावेज़',
      textPromptToUpgrade: 'अगर आपको फोटो अपलोड करने में समस्या हो रही है, तो ऐप के नवीनतम संस्करण को डाउनलोड और इंस्टॉल करने के लिए कृपया नीचे दिए गए लिंक को अपने ब्राउज़र में कॉपी और पेस्ट करने के लिए टैप करें।',
      copyLnk: 'लिंक कॉपी करें',
      textFrontSide: 'आपके आधार कार्ड का फ्रंट साइड',
      textBackSide: 'आपके आधार कार्ड का पिछला भाग',
      textPhoto: 'आधार कार्ड पकड़े हुए स्वयं की तस्वीर',
      textFullName: 'पूरा नाम',
      textBirthday: 'जन्मदिन',
      textCardNumber: 'आधार कार्ड नंबर',
      textMobileNumber: 'मोबाइल नंबर',
      textYourBank: 'आपका बैंक खाता',
      promptFillName: 'कृपया अपना पूरा नाम भरें',
      promptFillBirthday: 'कृपया अपना जन्मदिन सही प्रारूप dd-mm-yyyy में भरें, उदा. 31-01-1998',
      promptFillCard: 'कृपया अपना आधार कार्ड नंबर भरें',
      promptCardInvalid: 'आधार कार्ड संख्या अमान्य है',
      promptUploadFrontCard: 'कृपया अपने आधार कार्ड का अगला भाग अपलोड करें',
      promptUploadBackCard: 'कृपया अपने आधार कार्ड का पिछला भाग अपलोड करें',
      promptUploadPhoto: 'कृपया अपना आधार कार्ड पकड़े हुए फोटो अपलोड करें',
      errorUpload: 'अपलोड करते समय त्रुटि हुई। कृपया पुन: प्रयास करें।',
      promptInvalidAccountName: 'खाते का नाम अंग्रेजी अक्षरों में होना चाहिए',
      promptInvalidCard: 'बैंक कोड (IFSC कोड) अमान्य है',
      promptInvalidAccount: 'खाता संख्या अमान्य है',
      promptFillAccountName: 'कृपया खाता नाम भरें',
      promptFillAccountNumber: 'कृपया खाता संख्या भरें',
      promptFillIFSC: 'कृपया बैंक कोड (IFSC कोड) भरें'
    },
    claimAmount: 'दावा राशि',
    vip: {
      vip: 'वीआईपी',
      svip: 'एसवीआईपी',
      myVipStatus: 'मेरा VIP स्टेटस',
      vipRules: 'नियम',
      currentVIPStatus: 'वर्तमान VIP स्थिति',
      offer: 'प्रस्ताव',
      bonus: 'बोनस',
      everyDeposit: 'हर डिपॉजिट',
      condition: 'स्थिति',
      singleDeposit: 'सिंगल डिपॉजिट',
      monthlyDeposit: 'मासिक जमा',
      deposit: 'जमा',
      or: 'या',
      vipPrompt: 'भारी बोनस प्राप्त करने के लिए VIP बनें',
      rules: [
        'जब आप PGEBet VIP सदस्य बन जाते हैं, तो आपके द्वारा किए गए हर डिपॉजिट पर आपको 100% बोनस मिलेगा!',
        'जब आप PGEBet SVIP (सुपर VIP) सदस्य बन जाते हैं, तो आपके द्वारा किए गए प्रत्येक जमा पर आपको 150% बोनस प्राप्त होगा!',
        'तुरंत वीआईपी बनने के लिए मौजूदा महीने में ₹5,000 से अधिक का एक सिंगल डिपॉजिट करें या कुल ₹20,000 से अधिक जमा करें। आप अपनी पिछली जमा राशि से अपना बोनस तुरंत प्राप्त करेंगे।',
        '10,000 रुपये से अधिक का एक सिंगल डिपॉजिट करें या चालू माह के लिए कुल 50,000 रुपये से अधिक जमा करें और तत्काल एसवीआईपी बनें। आप अपनी पिछली जमा राशि से अपना बोनस तुरंत प्राप्त करेंगे।',
        'आपकी VIP/SVIP सदस्यता हर महीने के अंतिम दिन समाप्त होती है। फिर से VIP/SVIP बनने के लिए अगले महीने की शुरुआत में अपनी आवश्यक राशि जमा करें।'
      ]
    },
    noBonusReadyForClaim: 'वर्तमान में नकदी के दावे के लिए कोई बोनस तैयार नहीं है',
    bonusWagering: 'बोनस दांव लगाने की आवश्यकताएं',
    bonusPrompt: 'माय बोनस | बोनस कैसे काम करता है',
    claimBonus: 'दावा बोनस',
    bonusRequirement: 'दांव लगाना',
    howDoesBonusWork: 'यह कैसे काम करता है?',
    howDoesBonusWorkItems: [
      'बोनस PGEBet खिलाड़ियों के लिए एक विशेष पेशकश है जिसे खिलाड़ियों के नकद शेष में बदला जा सकता है।',
      'हम प्रचार शर्तों के आधार पर आपके खाते में बोनस जमा करते हैं।',
      'जब भी आप अपनी शर्त (दांव) लगाते हैं तो आपकी बोनस राशि की एक निश्चित राशि हर बार परिवर्तित हो जाती है। जितनी अधिक आप शर्त लगाते हैं या दांव लगाते हैं, उतनी ही तेजी से आपका बोनस रूपांतरित होता है।',
      'आप किसी भी समय परिवर्तित बोनस की किसी भी राशि को अपने कैश बैलेंस में दावा कर सकते हैं।'
    ],
    whatIsBonus: 'बोनस क्या है?',
    whatIsBonusContent: '<div>दांव लगाने की आवश्यकता, जैसा कि अक्सर कहा जाता है, वह मूल्य राशि है जिसे आपको अपने बोनस बैलेंस को वास्तविक धन में बदलने और निकासी के योग्य बनने के लिए दांव लगाने की आवश्यकता होती है। उदाहरण के लिए: यदि कोई खिलाड़ी 100% बोनस के साथ ₹1,000 जमा करता है और उस बोनस में 40X दांव लगाने की आवश्यकता होती है, तो इसका मतलब होगा कि आपके खाते में जमा बोनस राशि (₹1,000) को केवल परिवर्तित किया जा सकता है और आपके नकद खाते में दावा किया जा सकता है यदि आपने आपकी बोनस राशि पर 40X (40 गुना) दाँव लगाया या खेला</div>' +
      '<div style="margin-top: 10px;">100% जमा बोनस प्रमोशन पर ₹1,000 जमा = ₹1,000 बोनस राशि</div>' +
      '<div style="margin-top: 10px;">इस उदाहरण में, ₹1,000 बोनस राशि X 40 आपकी दांव लगाने की आवश्यकता है = ₹40,000</div>' +
      '<div style="margin-top: 10px;">एक बार जब आप अपने कैश बैलेंस के साथ ₹40,000 मूल्य की बेट लगा लेते हैं (उदाहरण के लिए प्रत्येक ₹4,000 के 10 दांव हो सकते हैं), तो आपकी बोनस राशि पूरी तरह से परिवर्तित हो जाएगी (\'B\' बैलेंस में प्रगति देखें)। आप अपने मुख्य नकद शेष राशि के लिए \'बी\'शेष राशि का दावा कर सकते हैं और फिर आप अपने धन को निकालने के लिए पात्र हैं।</div>' +
      '<div style="margin-top: 10px;">कृपया ध्यान दें कि आपको पूरी बोनस राशि परिवर्तित होने तक प्रतीक्षा करने की आवश्यकता नहीं है। प्रत्येक रुपया जो बेट है, बोनस राशि को 40/40 की दर से परिवर्तित करेगा</div>' +
      '<div style="margin-top: 10px;">So:' +
      '<div style="margin-top: 10px;">यदि आप अपने कैश बैलेंस के साथ ₹40 की शर्त लगाते हैं, तो आपका रूपांतरित बोनस 40/40 = ₹1 है</div>' +
      '<div style="margin-top: 10px;">कुल ₹10,000 की बेट लगाने के बाद, आपका परिवर्तित बोनस 10,000/40 = ₹250 होता है</div>' +
      '<div style="margin-top: 10px;">आप शीर्ष मेनू पर \'B\' बैलेंस में अपनी बोनस परिवर्तित प्रगति देख सकते हैं। आप अपने कैश बैलेंस में किसी भी समय किसी भी \'बी\' बैलेंस राशि का दावा कर सकते हैं और निकाल सकते हैं।</div>' +
      '<div style="margin-top: 10px;">अधिक जानकारी के लिए, हमारे नियम और शर्तें पृष्ठ देखें।</div>',
    gameProviders: [
      {
        name: 'तीन पत्ती',
        provider: 'Jili'
      },
      {
        name: 'एके 47',
        provider: 'Jili'
      },
      {
        name: 'अंदर बहार',
        provider: 'Jili'
      },
      {
        name: 'रमी',
        provider: 'Jili'
      }
    ],
    convertBonusSuccess_1: 'आपने सफलतापूर्वक कनवर्ट किया है',
    convertBonusSuccess_2: 'आपके कैश बैलेंस के लिए बोनस',
    readyForClaim: 'कैश के दावे के लिए तैयार',
    bonusBalance: 'बोनस बैलेंस',
    moreBonus: 'अधिक बोनस',
    isHot: 'हॉट',
    currencyType: '₹',
    recommended: 'अनुशंसित',
    yesWithdraw: 'जमा करें',
    noWithdraw: 'रद्द करें'
  },
  setting: {
    setting: 'सेटिंग',
    myInfo: 'मेरी जानकारी',
    mobile: 'मोबाइल नंबर',
    depositCurrency: 'जमा मुद्रा',
    save: 'बचाना',
    saveSuccess: 'सेव सक्सेस',
    usernameExist: 'उपयोगकर्ता नाम मौजूद है',
    incorrectBirthday: 'कृपया अपना जन्मदिन dd-mm-yyyy प्रारूप में दर्ज करें, उदा. 31-01-2000',
    myHistory: 'मेरा इतिहास',
    status: 'स्थिति',
    system: 'सिस्टम',
    event: 'घटना',
    personal: 'व्यक्तिगत',
    logout: 'लॉग आउट',
    birthdayTip: 'सहेजने के बाद बदला नहीं जा सकता'
  },
  privacy: [
    {
      class: 't2',
      content: 'आपकी गोपनीयता हमारे लिए महत्वपूर्ण है। यह PGEBet की नीति है कि हमारी साइट, https://www.pgebet.com, और PGEBet ऐप सहित हमारे स्वामित्व वाली और संचालित अन्य साइटों पर हम आपसे एकत्र की जाने वाली किसी भी जानकारी के संबंध में आपकी गोपनीयता का सम्मान करते हैं।'
    },
    {
      class: 't2',
      content: 'हम केवल व्यक्तिगत जानकारी मांगते हैं जब हमें वास्तव में आपको सेवा प्रदान करने के लिए इसकी आवश्यकता होती है। हम इसे आपके ज्ञान और सहमति से उचित और वैध तरीकों से एकत्र करते हैं। हम आपको यह भी बताते हैं कि हम इसे क्यों एकत्र कर रहे हैं और इसका उपयोग कैसे किया जाएगा।'
    },
    {
      class: 't2',
      content: 'हम केवल तब तक एकत्रित जानकारी को बनाए रखते हैं जब तक कि आपको आपकी अनुरोधित सेवा प्रदान करने के लिए आवश्यक हो। हम जो डेटा संग्रहीत करते हैं, हम नुकसान और चोरी को रोकने के साथ-साथ अनधिकृत पहुंच, प्रकटीकरण, प्रतिलिपि, उपयोग या संशोधन को रोकने के लिए व्यावसायिक रूप से स्वीकार्य साधनों के भीतर सुरक्षा करेंगे।'
    },
    {
      class: 't2',
      content: 'हम सार्वजनिक रूप से या तृतीय-पक्ष के साथ व्यक्तिगत रूप से पहचानी जाने वाली किसी भी जानकारी को साझा नहीं करते हैं।'
    },
    {
      class: 't2',
      content: 'हमारी साइट उन बाहरी साइटों से लिंक हो सकती है जो हमारे द्वारा संचालित नहीं हैं। कृपया ध्यान रखें कि इन साइटों की सामग्री और प्रथाओं पर हमारा कोई नियंत्रण नहीं है, और हम उनकी संबंधित गोपनीयता नीतियों के लिए जिम्मेदारी या उत्तरदायित्व स्वीकार नहीं कर सकते।'
    },
    {
      class: 't2',
      content: 'आप अपनी व्यक्तिगत जानकारी के लिए हमारे अनुरोध को अस्वीकार करने के लिए स्वतंत्र हैं, इस समझ के साथ कि हम आपको आपकी कुछ वांछित सेवाएं प्रदान करने में असमर्थ हो सकते हैं।'
    },
    {
      class: 't2',
      content: 'हमारे ऑनलाइन कैसीनो/साइट के आपके निरंतर उपयोग को गोपनीयता और व्यक्तिगत जानकारी के आसपास हमारी प्रथाओं की स्वीकृति के रूप में माना जाएगा। यदि आपके पास इस बारे में कोई प्रश्न हैं कि हम उपयोगकर्ता डेटा और व्यक्तिगत जानकारी को कैसे प्रबंधित करते हैं, तो बेझिझक हमसे संपर्क करें।'
    },
    {
      class: 't2',
      content: 'यह नीति 12 जुलाई 2020 तक प्रभावी है।'
    }
  ],
  responsible: [
    {
      class: 't0',
      content: 'जिम्मेदार गेमिंग'
    },
    {
      class: 't2',
      content: 'कृपया अपने फायदे के लिए इस जानकारी को ध्यान से पढ़ें। '
    },
    {
      class: 't2',
      content: 'PGEBet प्राइमटाइम गेमिंग एंड एंटरटेनमेंट N.V द्वारा संचालित है, जिसका कार्यालय Zuikertuintjeweg (Zuikertuin Tower), Willemstad, Curacao में है। कंपनी पंजीकरण संख्या 160961।'
    },
    {
      class: 't2',
      content: '<i>व्याख्या</i>'
    },
    {
      class: 't2',
      content: 'जिन शब्दों के प्रारंभिक अक्षर बड़े अक्षरों में हैं, उनके अर्थ निम्नलिखित शर्तों के तहत परिभाषित किए गए हैं।'
    },
    {
      class: 't2',
      content: 'निम्न परिभाषाओं का एक ही अर्थ होगा चाहे वे एकवचन में या बहुवचन में दिखाई दें।'
    },
    {
      class: 't2',
      content: '<i>परिभाषाएँ</i>'
    },
    {
      class: 't2',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>अकाउंट का मतलब है कि हमारी सेवा या हमारी सेवा के कुछ हिस्सों तक पहुंचने के लिए आपके लिए बनाया गया एक अनूठा खाता।'
    },
    {
      class: 't2',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>कंपनी (इस अनुबंध में "कंपनी", "हम", "हमें" या "हमारा" कहा गया है) टू प्राइमटाइम गेमिंग एंड एंटरटेनमेंट एन.वी.'
    },
    {
      class: 't2',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>सेवा वेबसाइट को संदर्भित करती है।'
    },
    {
      class: 't2',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>वेबसाइट www.pgebet.com या संबद्ध साइटों/ऐप्स को संदर्भित करती है।'
    },
    {
      class: 't2',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>आपका मतलब सेवा, या कंपनी, या अन्य कानूनी इकाई तक पहुँचने या उपयोग करने वाला व्यक्ति है, जिसकी ओर से ऐसा व्यक्ति पहुँच रहा है या सेवा का उपयोग, जैसा लागू हो।'
    },
    {
      class: 't1',
      content: 'जिम्मेदार जुआ और स्वयं का बहिष्कार'
    },
    {
      class: 't2',
      content: 'जुआ हमारे अधिकांश उपयोगकर्ताओं के लिए मनोरंजन, मस्ती और उत्साह का मतलब है। लेकिन हम यह भी जानते हैं कि हमारे कुछ उपयोगकर्ताओं के लिए जुए के नकारात्मक दुष्प्रभाव हैं।'
    },
    {
      class: 't2',
      content: 'शुरुआत से ही हमने इस समस्या पर विचार किया है और जरूरत पड़ने पर मदद करने की पूरी कोशिश की है। "जिम्मेदार जुआ" के तहत हम उपायों के कई चरणों को समझते हैं, जिसके साथ एक जुआ प्रदाता नकारात्मक दुष्प्रभावों के प्रकट होने की संभावना को कम करने में मदद कर सकता है। यदि वे पहले ही सामने आ जाते हैं तो हम उनके खिलाफ सक्रिय कदम उठाने का भी प्रयास करते हैं।'
    },
    {
      class: 't2',
      content: 'जुए से होने वाले नकारात्मक दुष्प्रभावों के खिलाफ सबसे महत्वपूर्ण साधन जुए के जोखिमों के बारे में ज्ञान और शिक्षा है, ताकि हमारे उपयोगकर्ताओं के आत्म-नियंत्रण का समर्थन किया जा सके ताकि यह सुनिश्चित हो सके कि वे नकारात्मक दुष्प्रभावों से पीड़ित नहीं हैं।'
    },
    {
      class: 't2',
      content: 'इसके अलावा, यदि आपको लगता है कि आप जुए के आदी हैं, तो आप आत्म-परीक्षण भी कर सकते हैं: <a target="_blank" style="color:dark;" href="https://www.begambleaware.org/gambling-problems/do-i-have-a-gambling-problem/ ">https://www.begambleaware.org/gambling-problems/do-i-have-a-gambling-problem/ </a>'
    },
    {
      class: 't2',
      content: 'और आप जुए की लत के बारे में अतिरिक्त जानकारी यहां भी प्राप्त कर सकते हैं: <a target="_blank" style="color:dark;" href="https://www.begambleaware.org/safer-gambling/">https://www.begambleaware.org/safer-gambling/</a> '
    },
    {
      class: 't2',
      content: 'PGEBet में हम ऐसे प्लेटफॉर्म और सेवाएं प्रदान करते हैं जो हमारे ग्राहकों को गेम खेलने और दांव लगाने का आनंद लेने की अनुमति देते हैं। हमारा लक्ष्य एक सुरक्षित, स्थिर वातावरण प्रदान करना है जो आपको एक संतोषजनक और पुरस्कृत अनुभव प्रदान करेगा। हम अपने ग्राहकों को जिम्मेदारी से और उचित तरीके से हमारी सेवाओं का उपयोग करने के लिए प्रोत्साहित करते हैं। हम आपको मज़े करने के लिए प्रोत्साहित करते हैं और हम केवल मज़े करते हुए अपने ग्राहकों को इसकी सलाह देते हैं।'
    },
    {
      class: 't1',
      content: 'PGEBet पर जिम्मेदार जुआ के लिए सहायक संकेत'
    },
    {
      class: 't2',
      content: 'PGEBet में ग्राहकों की भलाई अत्यंत महत्वपूर्ण है। हम अपनी जुए की भूमिका को बहुत गंभीरता से लेते हैं और आपको सलाह देते हैं कि:'
    },
    {
      class: 't2',
      content: '1.अपनी सट्टेबाजी और जुआ खेलने को मनोरंजन का एक रूप मानें और आपके द्वारा निर्धारित धन का उपयोग केवल अपने मनोरंजन के लिए करें।'
    },
    {
      class: 't2',
      content: '2.डिपॉजिट लिमिट: आपके द्वारा सेट की गई लिमिट से ज्यादा बेट न लगाएं।'
    },
    {
      class: 't2',
      content: '3. पैसे के साथ शर्त मत लगाओ कि आप हार नहीं सकते। '
    },
    {
      class: 't2',
      content: '4.अपने नुकसान का पीछा मत करो।'
    },
    {
      class: 't2',
      content: '5.अपने दांव और/या गेम खेलने को अन्य गतिविधियों के लिए समय के उपयोग को रोकने न दें।'
    },
    {
      class: 't2',
      content: '6.ब्रेक लें: थके होने पर आपको ब्रेक लेना चाहिए या अब ध्यान केंद्रित नहीं कर सकते।'
    },
    {
      class: 't2',
      content: '7.केवल एक खाता: जुए पर आप कितना समय और पैसा खर्च करते हैं, इसका अवलोकन करना आसान बनाने के लिए।'
    },
    {
      class: 't2',
      content: 'यदि आपको जुए के व्यवहार के बारे में चिंता है या आपको लगता है कि आप इन दिशानिर्देशों का पालन करने में असमर्थ हैं, तो हम आपको एक प्रमाणित संगठन से सलाह लेने के लिए प्रोत्साहित करते हैं जो सहायता और सलाह प्रदान कर सकता है।'
    },
    {
      class: 't1',
      content: 'सूचना/संपर्क और स्व-बहिष्करण'
    },
    {
      class: 't2',
      content: 'इसके अलावा, यदि आप हमारी स्व-बहिष्करण प्रक्रिया पर चर्चा करना चाहते हैं, तो आप PGEBet के कर्मचारियों से Support@PGEBet.com पर संपर्क कर सकते हैं। कृपया ध्यान रखें कि हमारी स्व-बहिष्करण नीति के तहत बंद किए गए खातों को किसी भी कारण से रद्द या फिर से खोला नहीं जा सकता है। हालांकि, स्व-बहिष्करण अवधि समाप्त हो जाने के बाद, हम आपको यह सूचित करने के लिए एक ईमेल भेजेंगे कि आपका खाता फिर से सक्रिय हो गया है। "स्व-बहिष्करण" का अर्थ है, कि आप स्वयं को, अपनी पसंद से, सभी जुआ सेवाओं से बाहर कर देते हैं। स्व-बहिष्करण के दौरान आपको एक नया खाता बनाने की अनुमति नहीं है और स्व-बहिष्करण के दौरान एक नया खाता बनाने का प्रत्येक प्रयास हमारी सेवा की शर्तों का उल्लंघन है और इसके परिणामस्वरूप आपके मूल खाते को स्थायी रूप से प्रतिबंधित किया जा सकता है।'
    },
    {
      class: 't1',
      content: 'मामूली सुरक्षा'
    },
    {
      class: 't2',
      content: 'हमारी सेवा का उपयोग करने के लिए, आपकी आयु 18 वर्ष या उससे अधिक होनी चाहिए या आपके क्षेत्राधिकार में जुए के लिए न्यूनतम कानूनी आयु होनी चाहिए जिसमें आप रहते हैं। और आप पर लागू होने वाले कानूनों के तहत कानून द्वारा अनुमति दी गई है। दुरुपयोग से बचने के लिए, अपने पास के किसी भी अवयस्क से अपना लॉगिन डेटा सुरक्षित रखें।'
    },
    {
      class: 't2',
      content: 'मुख्य रूप से हम इंटरनेट पर किसी भी संदर्भ तक पहुँचने के लिए नाबालिगों, विशेष रूप से बच्चों से बचने के लिए एक फिल्टर प्रोग्राम की सलाह देते हैं, जो उनके लिए स्वस्थ नहीं है।'
    },
    {
      class: 't2',
      content: 'माता-पिता के लिए हम उन्हें समर्थन देने के लिए इंटरनेट फिल्टर की एक सूची की सिफारिश कर सकते हैं: <a target="_blank" style="color:dark;" href="https://famisafe.wondershare.com/internet-filter/best-internet-filters.html">https://famisafe.wondershare.com/internet-filter/best-internet-filters.html</a>'
    }
  ],
  terms: [
    {
      class: 't0',
      content: 'नियम और शर्तें'
    },
    {
      class: 't1',
      content: '1.परिचय'
    },
    {
      class: 't2',
      content: 'ये नियम और शर्तें और नीचे दिए गए दस्तावेज़ ("शर्तें") वर्तमान वेबसाइट ("वेबसाइट") और इससे संबंधित या संबंधित सेवाओं (सामूहिक रूप से, "सेवा") के उपयोग पर लागू होते हैं, जिसमें PGEBet शामिल है। अनुप्रयोग'
    },
    {
      class: 't2',
      content: 'आपको इन शर्तों की सावधानीपूर्वक समीक्षा करनी चाहिए क्योंकि इनमें वेबसाइट के उपयोग से संबंधित आपके अधिकारों और दायित्वों से संबंधित महत्वपूर्ण जानकारी होती है और आपके - हमारे ग्राहक ("ग्राहक"), और हमारे बीच एक बाध्यकारी कानूनी समझौता होता है। इस वेबसाइट का उपयोग करके और/या सेवा का उपयोग करके, आप, चाहे आप एक अतिथि हैं या एक खाते ("खाता") के साथ एक पंजीकृत उपयोगकर्ता हैं, इन शर्तों से बंधे होने के लिए सहमत हैं, साथ में किसी भी संशोधन के साथ, जो समय से प्रकाशित हो सकता है। समय पर। यदि आप इन शर्तों को स्वीकार नहीं करते हैं, तो आपको सेवा तक पहुँचने और वेबसाइट का उपयोग करने से बचना चाहिए।'
    },
    {
      class: 't2',
      content: 'सेवा का स्वामित्व प्राइमटाइम गेमिंग एंड एंटरटेनमेंट एन.वी के पास है, जो कुराकाओ में पंजीकृत एक सीमित देयता कंपनी है, जिसका पंजीकरण नंबर 160961 है और इसका पता ज़ुइकेर्टुइंटजेवेग (ज़ुइकेर्टुइन टॉवर), विलेमस्टैड, कुराकाओ ("कंपनी") में है।'
    },
    {
      class: 't1',
      content: '2.सामान्य शर्तें'
    },
    {
      class: 't2',
      content: 'हम किसी भी समय शर्तों को संशोधित करने और संशोधित करने का अधिकार सुरक्षित रखते हैं (नीचे संदर्भित और लिंक किए गए किसी भी दस्तावेज़ सहित)। नियमों और शर्तों की समीक्षा करने के लिए आपको समय-समय पर इस पृष्ठ पर जाना चाहिए। इस वेबसाइट पर प्रकाशन के तुरंत बाद संशोधन बाध्यकारी और प्रभावी होंगे। यदि आप ऐसे किसी भी बदलाव पर आपत्ति जताते हैं, तो आपको सेवा का उपयोग तुरंत बंद कर देना चाहिए। इस तरह के प्रकाशन के बाद वेबसाइट का आपका निरंतर उपयोग संशोधित शर्तों से बंधे होने के लिए आपके समझौते का संकेत देगा। परिवर्तित शर्तों के प्रभावी होने से पहले तय न की गई कोई भी बेट पहले से मौजूद शर्तों के अधीन होगी।'
    },
    {
      class: 't1',
      content: '3. आपके दायित्व'
    },
    {
      class: 't2',
      content: 'आप स्वीकार करते हैं कि वेबसाइट तक पहुँचने और सेवा का उपयोग करते समय हर समय:'
    },
    {
      class: 't2',
      content: '3.1.आपकी आयु 18 वर्ष से अधिक है, या कानूनी उम्र जिस पर आप पर लागू होने वाले कानून या अधिकार क्षेत्र के तहत जुआ, या गेमिंग गतिविधियों की अनुमति है। हम किसी भी समय आपसे उम्र के दस्तावेजों के प्रमाण का अनुरोध करने का अधिकार सुरक्षित रखते हैं।'
    },
    {
      class: 't2',
      content: '3.2.आप कानूनी क्षमता के हैं और हमारे साथ एक बाध्यकारी कानूनी समझौता कर सकते हैं। यदि आप कानूनी क्षमता के नहीं हैं तो आपको वेबसाइट का उपयोग नहीं करना चाहिए या सेवा का उपयोग नहीं करना चाहिए।अपनी सट्टेबाजी का इलाज करें'
    },
    {
      class: 't2',
      content: '3.3. आप एक ऐसे अधिकार क्षेत्र के निवासी हैं जो जुए की अनुमति देता है। आप किसी भी ऐसे देश के निवासी नहीं हैं जहां के निवासियों या ऐसे देश के भीतर किसी भी व्यक्ति के लिए ऑनलाइन जुए की पहुंच प्रतिबंधित है। यह सुनिश्चित करना आपका एकमात्र उत्तरदायित्व है कि सेवा का आपका उपयोग कानूनी है।'
    },
    {
      class: 't2',
      content: '3.4. आप किसी वीपीएन, प्रॉक्सी या इसी तरह की सेवाओं/उपकरणों का उपयोग नहीं कर सकते हैं जो आपके वास्तविक स्थान की पहचान को छिपाते हैं या हेरफेर करते हैं।'
    },
    {
      class: 't2',
      content: '3.5.आप जिस भुगतान विधि का उपयोग करते हैं, उसके आप अधिकृत उपयोगकर्ता हैं।'
    },
    {
      class: 't2',
      content: '3.6.आपको हमें सभी भुगतान नेकनीयती से करने चाहिए और किए गए भुगतान को वापस करने का प्रयास नहीं करना चाहिए या ऐसी कोई कार्रवाई नहीं करनी चाहिए जिससे ऐसा भुगतान किसी तीसरे पक्ष द्वारा वापस किया जा सके।'
    },
    {
      class: 't2',
      content: '3.7. दांव लगाते समय आप इन शर्तों के अनुसार सेवा में जमा किए गए अपने कुछ या सभी पैसे खो सकते हैं और उस नुकसान के लिए आप पूरी तरह से जिम्मेदार होंगे।'
    },
    {
      class: 't2',
      content: '3.8.दांव लगाते समय आपको उस देश में लागू किसी भी कानून के उल्लंघन में प्राप्त किसी भी जानकारी का उपयोग नहीं करना चाहिए जिसमें आप शर्त लगाते समय थे।'
    },
    {
      class: 't2',
      content: '3.9.आप किसी अन्य पार्टी की ओर से या किसी व्यावसायिक उद्देश्य के लिए काम नहीं कर रहे हैं, बल्कि एक निजी क्षमता में एक निजी व्यक्ति के रूप में केवल अपनी ओर से काम कर रहे हैं।'
    },
    {
      class: 't2',
      content: '3.10.आपको या तो सेवा के भीतर किसी भी बाजार या तत्व को खराब विश्वास में हेरफेर करने का प्रयास नहीं करना चाहिए और न ही इस तरह से जो सेवा या हमारी अखंडता पर प्रतिकूल प्रभाव डालता है।'
    },
    {
      class: 't2',
      content: '3.11.आपको आम तौर पर हर समय सेवा के संबंध में और सेवा का उपयोग करके किए गए सभी दांवों के लिए नेकनीयती से कार्य करना चाहिए।'
    },
    {
      class: 't1',
      content: '4.प्रतिबंधित उपयोग'
    },
    {
      class: 't2',
      content: '4.1.आपको सेवा का उपयोग नहीं करना चाहिए:'
    },
    {
      class: 't2',
      content: '4.1.1.यदि आपकी आयु 18 वर्ष से कम है (या आप पर लागू अधिकार क्षेत्र के कानूनों में निर्धारित वयस्कता की आयु से कम) या यदि आप कानूनी रूप से हमारे साथ बाध्यकारी कानूनी समझौते में प्रवेश करने में सक्षम नहीं हैं या आप एक एजेंट के रूप में कार्य कर रहे हैं 18 वर्ष से कम आयु के व्यक्ति के लिए, या अन्यथा, (या आपके लिए लागू अधिकार क्षेत्र के कानूनों में निर्धारित वयस्कता की आयु से कम);'
    },
    {
      class: 't2',
      content: '4.1.2.अगर आप किसी ऐसे देश में रहते हैं जहां के निवासियों या ऐसे देश के भीतर किसी भी व्यक्ति के लिए ऑनलाइन जुए की पहुंच प्रतिबंधित है।'
    },
    {
      class: 't2',
      content: '4.1.3.यदि आप निम्नलिखित देशों में से किसी एक के निवासी हैं, या निम्नलिखित देशों में से किसी एक से वेबसाइट का उपयोग कर रहे हैं:'
    },
    {
      class: 't2',
      content: '<i style="margin-left: 20px;">●&nbsp;</i>संयुक्त राज्य अमेरिका और उसके क्षेत्र,'
    },
    {
      class: 't2',
      content: '<i style="margin-left: 20px;">●&nbsp;</i>फ्रांस और उसके क्षेत्र,'
    },
    {
      class: 't2',
      content: '<i style="margin-left: 20px;">●&nbsp;</i>नीदरलैंड और उसके क्षेत्र और देश जो हॉलैंड साम्राज्य बनाते हैं, जिसमें बोनेयर, सिंट यूस्टैटियस, सबा, अरूबा, कुराकाओ और सिंट मार्टेन शामिल हैं,'
    },
    {
      class: 't2',
      content: '<i style="margin-left: 20px;">●&nbsp;</i>ऑस्ट्रेलिया और उसके क्षेत्र,'
    },
    {
      class: 't2',
      content: '<i style="margin-left: 20px;">●&nbsp;</i>ग्रेट ब्रिटेन और उत्तरी आयरलैंड का यूनाइटेड किंगडम,'
    },
    {
      class: 't2',
      content: '<i style="margin-left: 20px;">●&nbsp;</i>स्पेन'
    },
    {
      class: 't2',
      content: '4.1.4.किसी भी तरह से अन्य ग्राहकों के उपनाम, ई-मेल पते और/या अन्य जानकारी एकत्र करने के लिए (उदाहरण के लिए, स्पैम भेजकर, अन्य प्रकार के अवांछित ईमेल या सेवा के अनधिकृत फ़्रेमिंग, या उससे लिंक करके);'
    },
    {
      class: 't2',
      content: '4.1.5. अन्य ग्राहकों की गतिविधियों या सामान्य रूप से सेवा के संचालन को बाधित या अनुचित रूप से प्रभावित या प्रभावित करने के लिए;'
    },
    {
      class: 't2',
      content: '4.1.6.अवांछित वाणिज्यिक विज्ञापनों, सहबद्ध लिंक, और आग्रह के अन्य रूपों को बढ़ावा देने के लिए जिन्हें बिना सूचना के सेवा से हटाया जा सकता है;'
    },
    {
      class: 't2',
      content: '4.1.7.किसी भी तरह से, जिसे हमारी उचित राय में, निम्नलिखित के प्रयास के रूप में माना जा सकता है: (i) सेवा या सेवा का उपयोग करने वाले किसी अन्य ग्राहक को धोखा देना; या (ii) बेईमान लाभ प्राप्त करने के लिए सेवा का उपयोग करने वाले किसी अन्य ग्राहक के साथ मिलीभगत करना;'
    },
    {
      class: 't2',
      content: '4.1.8.हमारी बाधाओं को दूर करने या हमारे किसी भी बौद्धिक संपदा अधिकार का उल्लंघन करने के लिए; या'
    },
    {
      class: 't2',
      content: '4.1.9.किसी भी गैरकानूनी गतिविधि के लिए'
    },
    {
      class: 't2',
      content: '4.2.आप किसी भी तरह से खिलाड़ी के खातों के बीच फंड ट्रांसफर नहीं कर सकते।'
    },
    {
      class: 't2',
      content: '4.3. आप किसी भी तरह से खिलाड़ी के खातों के बीच फंड ट्रांसफर नहीं कर सकते हैं।'
    },
    {
      class: 't2',
      content: '4.4.यदि आप अनधिकृत उद्देश्यों के लिए सेवा का उपयोग करते हैं तो हम आपको लिखित नोटिस देकर तुरंत आपका खाता समाप्त कर सकते हैं। कुछ खास परिस्थितियों में ऐसा करने पर हम आपके खिलाफ कानूनी कार्रवाई भी कर सकते हैं।'
    },
    {
      class: 't2',
      content: '4.5.कंपनी के कर्मचारियों, उसके लाइसेंसधारियों, वितरकों, थोक विक्रेताओं, सहायक कंपनियों, विज्ञापन, प्रचार या अन्य एजेंसियों, मीडिया भागीदारों, ठेकेदारों, खुदरा विक्रेताओं और प्रत्येक के तत्काल परिवारों के सदस्यों को कंपनी से पूर्व सहमति के बिना वास्तविक धन के लिए सेवा का उपयोग करने की अनुमति नहीं है। निदेशक। यदि ऐसी गतिविधि का पता चलता है, तो खाता (खातों) को तुरंत समाप्त कर दिया जाएगा और सभी बोनस/जीत को जब्त कर लिया जाएगा।'
    },
    {
      class: 't1',
      content: '5. पंजीकरण'
    },
    {
      class: 't2',
      content: 'आप सहमत हैं कि सेवा का उपयोग करते समय हर समय:'
    },
    {
      class: 't2',
      content: '5.1.हम किसी भी आवेदक से पंजीकरण आवेदन को स्वीकार करने से इनकार करने का अधिकार अपने विवेकाधिकार पर और बिना किसी विशेष कारण के संवाद करने के लिए सुरक्षित रखते हैं।'
    },
    {
      class: 't2',
      content: '5.2. सेवा का उपयोग करने से पहले, आपको व्यक्तिगत रूप से पंजीकरण फॉर्म भरना होगा और इन शर्तों को पढ़ना और स्वीकार करना होगा। सेवा पर सट्टेबाजी शुरू करने या अपनी जीत वापस लेने के लिए, हमें आपको एक सत्यापित ग्राहक बनने की आवश्यकता हो सकती है जिसमें कुछ चेक पास करना शामिल है। आपको पहचान का एक वैध प्रमाण और कोई अन्य दस्तावेज़ प्रदान करने की आवश्यकता हो सकती है, जैसा कि आवश्यक समझा जा सकता है। इसमें एक पिक्चर आईडी (पासपोर्ट, ड्राइवर के लाइसेंस या राष्ट्रीय आईडी कार्ड की कॉपी) और निवास के प्रमाण के रूप में आपके नाम और पते को सूचीबद्ध करने वाला एक हालिया यूटिलिटी बिल शामिल है, लेकिन यह इन्हीं तक सीमित नहीं है। आवश्यक जानकारी प्राप्त होने तक हम किसी भी खाते पर दांव लगाने या खाता विकल्पों को प्रतिबंधित करने का अधिकार सुरक्षित रखते हैं। यह प्रक्रिया लागू गेमिंग विनियमन और मनी-लॉन्ड्रिंग विरोधी कानूनी आवश्यकताओं के अनुसार की जाती है। इसके अतिरिक्त, आपको हमारी वेबसाइट के भुगतान अनुभाग में निर्धारित भुगतान विधियों का उपयोग करके अपने सेवा खाते में धन जमा करने की आवश्यकता होगी।'
    },
    {
      class: 't2',
      content: '5.3. आपको एक मान्य ईमेल पता ("पंजीकृत ईमेल पता") सहित सटीक संपर्क जानकारी प्रदान करनी होगी, और इसे सटीक रखने के लिए भविष्य में ऐसी जानकारी को अपडेट करना होगा। यह आपका उत्तरदायित्व है कि आप अपने संपर्क विवरण को अपने खाते में अद्यतन रखें। ऐसा करने में विफल होने पर आप हमारे द्वारा इन शर्तों में किए गए परिवर्तनों सहित खाते से संबंधित महत्वपूर्ण सूचनाएं और जानकारी प्राप्त करने में विफल हो सकते हैं। हम अपने ग्राहकों को उनके पंजीकृत ईमेल पते के माध्यम से पहचानते हैं और उनसे संवाद करते हैं। यह ग्राहक की जिम्मेदारी है कि वह एक सक्रिय और अद्वितीय ईमेल खाता बनाए रखे, हमें सही ईमेल पता प्रदान करे और कंपनी को उनके ईमेल पते में किसी भी बदलाव की सलाह दे। प्रत्येक ग्राहक किसी तीसरे पक्ष द्वारा अपने पंजीकृत ईमेल पते के उपयोग को रोकने के लिए अपने पंजीकृत ईमेल पते की सुरक्षा बनाए रखने के लिए पूरी तरह से जिम्मेदार है। कंपनी पंजीकृत ईमेल पते का उपयोग करके कंपनी और ग्राहक के बीच संचार के परिणामस्वरूप होने वाली किसी भी क्षति या नुकसान के लिए जिम्मेदार नहीं होगी। किसी भी ग्राहक के पास कंपनी द्वारा संपर्क करने योग्य ईमेल पता नहीं होने पर उसका खाता तब तक निलंबित कर दिया जाएगा जब तक कि ऐसा पता हमें प्रदान नहीं किया जाता है। यदि आप जानबूझकर गलत या गलत व्यक्तिगत जानकारी प्रदान करते हैं तो हम आपको इस आशय की लिखित सूचना देकर तुरंत आपके खाते को निलंबित कर देंगे। हम कुछ परिस्थितियों में ऐसा करने के लिए आपके खिलाफ कानूनी कार्रवाई भी कर सकते हैं और/या संबंधित अधिकारियों से संपर्क कर सकते हैं जो आपके खिलाफ कार्रवाई भी कर सकते हैं।'
    },
    {
      class: 't2',
      content: '5.4.आपको सेवा के साथ केवल एक खाता पंजीकृत करने की अनुमति है। यदि यह पाया जाता है कि हमारे पास एक से अधिक खाते पंजीकृत हैं तो खाते तत्काल बंद किए जा सकते हैं। इसमें आपकी ओर से काम करने वाले प्रतिनिधियों, रिश्तेदारों, सहयोगियों, सहयोगियों, संबंधित पक्षों, जुड़े व्यक्तियों और/या तीसरे पक्षों का उपयोग शामिल है।'
    },
    {
      class: 't2',
      content: '5.5.आपकी वित्तीय योग्यता सुनिश्चित करने और आपकी पहचान की पुष्टि करने के लिए, हम आपको अतिरिक्त व्यक्तिगत जानकारी प्रदान करने के लिए कह सकते हैं, जैसे कि आपका नाम और उपनाम, या किसी तीसरे पक्ष के सूचना प्रदाताओं का उपयोग करना जो हम आवश्यक समझते हैं। यदि तृतीय-पक्ष स्रोतों के माध्यम से कोई अतिरिक्त व्यक्तिगत जानकारी प्राप्त की जाती है, तो हम आपको प्राप्त डेटा के बारे में सूचित करेंगे।'
    },
    {
      class: 't2',
      content: '5.6.आपको सेवा के लिए अपना पासवर्ड गोपनीय रखना चाहिए। बशर्ते अनुरोध की गई खाता जानकारी सही ढंग से प्रदान की गई हो, हम यह मानने के हकदार हैं कि आपके द्वारा दांव, जमा और निकासी की गई है। हम आपको सलाह देते हैं कि आप अपना पासवर्ड नियमित रूप से बदलते रहें और कभी भी किसी तीसरे पक्ष को इसका खुलासा न करें। अपने पासवर्ड की सुरक्षा करना आपकी जिम्मेदारी है और ऐसा करने में कोई भी विफलता आपके जोखिम और खर्च पर होगी। आप प्रत्येक सत्र के अंत में सेवा से लॉग आउट कर सकते हैं। यदि आपको लगता है कि आपकी किसी भी खाता जानकारी का किसी तीसरे पक्ष द्वारा दुरुपयोग किया जा रहा है, या आपका खाता हैक कर लिया गया है, या आपका पासवर्ड किसी तीसरे पक्ष द्वारा खोज लिया गया है, तो आपको तुरंत हमें सूचित करना चाहिए। यदि आपका पंजीकृत ईमेल पता हैक कर लिया गया है, तो आपको हमें सूचित करना चाहिए, हालाँकि, हमें आपको अतिरिक्त जानकारी/दस्तावेज़ प्रदान करने की आवश्यकता हो सकती है ताकि हम आपकी पहचान सत्यापित कर सकें। ऐसी किसी घटना की जानकारी मिलते ही हम आपका खाता तुरंत निलंबित कर देंगे। इस बीच आप तीसरे पक्ष की पहुंच सहित अपने खाते की सभी गतिविधियों के लिए जिम्मेदार हैं, भले ही उनकी पहुंच आपके द्वारा अधिकृत की गई हो या नहीं।'
    },
    {
      class: 't2',
      content: '5.7.आपको किसी भी समय स्क्रीन कैप्चर (या अन्य समान विधि) के माध्यम से सेवा पर किसी भी सामग्री या अन्य जानकारी को किसी अन्य ग्राहक या किसी अन्य पार्टी को प्रसारित नहीं करना चाहिए, न ही किसी फ्रेम में या किसी अन्य तरीके से ऐसी कोई जानकारी या सामग्री प्रदर्शित करनी चाहिए यह इस बात से भिन्न है कि यदि ऐसा ग्राहक या तृतीय पक्ष ब्राउज़र लाइन में सेवा के लिए URL टाइप करता है तो यह कैसा दिखाई देगा।'
    },
    {
      class: 't2',
      content: '5.8.पंजीकरण करते समय, आपको वेबसाइट पर उपलब्ध सभी मुद्राओं का उपयोग करने की संभावना प्राप्त होगी। वे आपकी जमा, निकासी और लगाए गए दांव की मुद्राएं होंगी और इन शर्तों में निर्धारित सेवा में मेल खाती हैं। कुछ भुगतान विधियां सभी मुद्राओं में संसाधित नहीं होती हैं। ऐसे मामलों में पृष्ठ पर उपलब्ध रूपांतरण कैलकुलेटर के साथ एक प्रसंस्करण मुद्रा प्रदर्शित की जाएगी।'
    },
    {
      class: 't2',
      content: '5.9.हम आपके लिए एक खाता खोलने के लिए बाध्य नहीं हैं और हमारा वेबसाइट साइन-अप पृष्ठ केवल इलाज के लिए एक निमंत्रण है। यह पूरी तरह से हमारे विवेक पर निर्भर करता है कि आपके लिए खाता खोलना है या नहीं, और यदि हम आपके लिए खाता खोलने से इंकार करते हैं, तो हम आपको मना करने का कारण बताने के लिए बाध्य नहीं हैं।'
    },
    {
      class: 't2',
      content: '5.10.आपका आवेदन प्राप्त होने पर, हम अपने विनियामक और कानूनी दायित्वों का पालन करने के लिए आपसे अधिक जानकारी और/या दस्तावेज़ीकरण का अनुरोध करने के लिए संपर्क में रह सकते हैं।'
    },
    {
      class: 't1',
      content: '6.आपका खाता'
    },
    {
      class: 't2',
      content: '6.1.खाते कई मुद्राओं का उपयोग कर सकते हैं, इस मामले में सभी खाता शेष और लेन-देन लेनदेन के लिए उपयोग की जाने वाली मुद्रा में दिखाई देते हैं।'
    },
    {
      class: 't2',
      content: '6.2.हम सेवा के उपयोग का श्रेय नहीं देते हैं।'
    },
    {
      class: 't2',
      content: '6.3.यदि आप ऐसा नहीं करते हैं या हमें उचित रूप से विश्वास है कि आप इन शर्तों का अनुपालन नहीं कर रहे हैं, या सेवा की सत्यनिष्ठा या निष्पक्षता सुनिश्चित करने के लिए या यदि हमारे पास ऐसा करने के लिए अन्य उचित आधार हैं, तो हम किसी खाते को बंद या निलंबित कर सकते हैं। हम हमेशा आपको पूर्व सूचना देने में सक्षम नहीं हो सकते हैं। यदि हम इन शर्तों का पालन नहीं करने के कारण आपके खाते को बंद या निलंबित कर देते हैं, तो हम आपके किसी भी दांव को रद्द और/या रद्द कर सकते हैं और आपके खाते में कोई पैसा रोक सकते हैं (जमा सहित)।'
    },
    {
      class: 't2',
      content: '6.4. हम बिना किसी पूर्व सूचना के किसी भी खाते को बंद या निलंबित करने और सभी धनराशि वापस करने का अधिकार सुरक्षित रखते हैं। हालांकि पहले से परिपक्व संविदात्मक दायित्वों का सम्मान किया जाएगा।'
    },
    {
      class: 't2',
      content: '6.5.हम किसी भी कारण से किसी भी समय किसी भी दांव को मना करने, प्रतिबंधित करने, रद्द करने या सीमित करने का अधिकार सुरक्षित रखते हैं, जिसमें हमारी सट्टेबाजी की सीमा और/या हमारे सिस्टम नियमों को दरकिनार करने के लिए धोखाधड़ी के तरीके से लगाए गए किसी भी दांव को शामिल किया गया है।'
    },
    {
      class: 't2',
      content: '6.6.यदि कोई राशि गलती से आपके खाते में जमा हो जाती है तो यह हमारी संपत्ति बनी रहती है और जब हमें ऐसी किसी गलती का पता चलता है, तो हम आपको सूचित करेंगे और आपके खाते से राशि वापस ले ली जाएगी।'
    },
    {
      class: 't2',
      content: '6.7.यदि, किसी भी कारण से, आपका खाता अधिक आहरित हो जाता है, तो अधिक आहरित राशि के लिए आप हमारे ऋणी होंगे।'
    },
    {
      class: 't2',
      content: '6.8.अपने खाते के संबंध में किसी भी त्रुटि के बारे में पता चलते ही आपको हमें सूचित करना चाहिए।'
    },
    {
      class: 't2',
      content: '6.9.कृपया याद रखें कि सट्टेबाजी विशुद्ध रूप से मनोरंजन और आनंद के लिए है और जैसे ही यह मज़ेदार होना बंद हो जाए आपको रोक देना चाहिए। निश्चित रूप से ऐसी किसी भी चीज़ पर दांव न लगाएं जिसे आप खोना बर्दाश्त नहीं कर सकते। यदि आपको लगता है कि आपने अपने जुए पर नियंत्रण खो दिया है, तो हम एक स्व-बहिष्करण विकल्प प्रदान करते हैं। बस अपने पंजीकृत ईमेल पते का उपयोग करके हमारे ग्राहक सहायता विभाग को एक संदेश भेजें जिसे आप स्व-बहिष्कृत करना चाहते हैं और यह अनुरोध इसकी प्राप्ति के क्षण से 24 घंटों के भीतर प्रभावी होगा। इस मामले में आपका खाता आपकी अगली सूचना तक अक्षम कर दिया जाएगा, और आप इसमें प्रवेश नहीं कर पाएंगे'
    },
    {
      class: 't2',
      content: '6.10.आप अपना खाता किसी अन्य व्यक्ति को हस्तांतरित, बेच या गिरवी नहीं रख सकते हैं। इस निषेध में किसी भी प्रकार के मूल्य की किसी भी संपत्ति का हस्तांतरण शामिल है, जिसमें खातों के स्वामित्व, जीत, जमा, दांव, अधिकार और/या इन संपत्तियों के संबंध में कानूनी, वाणिज्यिक या अन्यथा तक सीमित नहीं है। उक्त हस्तांतरणों पर निषेध भी शामिल है, हालांकि यह भार, प्रतिज्ञा, असाइनिंग, सूदखोरी, व्यापार, दलाली, दृष्टिबंधन और/या किसी न्यासी या किसी अन्य तीसरे पक्ष, कंपनी, प्राकृतिक या कानूनी व्यक्ति, फाउंडेशन और के सहयोग से उपहार देने तक सीमित नहीं है। / या किसी भी तरह से आकार या रूप में जुड़ाव।'
    },
    {
      class: 't2',
      content: '6.11.यदि आप हमारे साथ अपना खाता बंद करना चाहते हैं, तो कृपया अपने पंजीकृत ईमेल पते से वेबसाइट पर लिंक के माध्यम से हमारे ग्राहक सहायता विभाग को एक ईमेल भेजें।'
    },
    {
      class: 't1',
      content: '7.निष्क्रिय खाते'
    },
    {
      class: 't2',
      content: '7.1.आपसे शुल्क लेना हमारे विवेक पर है यदि:'
    },
    {
      class: 't2',
      content: 'आपने अपने खाते में लॉग इन नहीं किया है या अपने खाते से लॉग आउट नहीं किया है, या सेवा का उपयोग नहीं किया है, या लगातार बारह महीनों या उससे अधिक (खाता गतिविधि) की अवधि के बाद सेवा के किसी भी भाग में कोई दांव नहीं लगाया है; और आपका खाता क्रेडिट में है।'
    },
    {
      class: 't2',
      content: '7.2.निष्क्रियता के ग्यारहवें महीने में आपको ऐसे किसी भी शुल्क के बारे में सूचित किया जाएगा और आपके पास हमेशा लॉग इन करने और अपनी धनराशि निकालने का विकल्प होगा।'
    },
    {
      class: 't2',
      content: '7.3.यदि आपके खाते से निष्क्रिय खाता शुल्क वापस लिया जाना है और आपके खाते की शेष राशि शुल्क से कम है, तो निष्क्रिय खाता शुल्क में आपके खाते की शेष राशि शामिल होगी।'
    },
    {
      class: 't1',
      content: '8.निधियों का जमा'
    },
    {
      class: 't2',
      content: '8.1.सभी जमा एक खाते या भुगतान प्रणाली या क्रेडिट कार्ड से किया जाना चाहिए जो आपके नाम पर पंजीकृत है, और किसी अन्य मुद्रा में किए गए किसी भी जमा को oanda.com से प्राप्त दैनिक विनिमय दर का उपयोग करके या हमारे अपने बैंक में परिवर्तित किया जाएगा। या हमारे भुगतान संसाधक की विनिमय की प्रचलित दर जिसके बाद आपका खाता तदनुसार जमा किया जाएगा। ध्यान दें कि कुछ भुगतान प्रणालियाँ अतिरिक्त मुद्रा विनिमय शुल्क लागू कर सकती हैं जो आपकी जमा राशि से काट ली जाएगी।'
    },
    {
      class: 't2',
      content: '8.2. शुल्क और शुल्क ग्राहक जमा और निकासी पर लागू हो सकते हैं, जो वेबसाइट पर पाया जा सकता है। ज्यादातर मामलों में हम आपके PGEBet खाते में जमा राशि के लिए लेनदेन शुल्क को अवशोषित करते हैं। आप अपने स्वयं के बैंक शुल्कों के लिए जिम्मेदार हैं जो आपको हमारे पास धनराशि जमा करने के कारण हो सकते हैं।'
    },
    {
      class: 't2',
      content: '8.3. कंपनी एक वित्तीय संस्थान नहीं है और क्रेडिट और डेबिट कार्ड जमा को संसाधित करने के लिए तीसरे पक्ष के इलेक्ट्रॉनिक भुगतान प्रोसेसर का उपयोग करती है; वे सीधे हमारे द्वारा संसाधित नहीं होते हैं। यदि आप क्रेडिट कार्ड या डेबिट कार्ड द्वारा धनराशि जमा करते हैं, तो आपके खाते में तभी क्रेडिट किया जाएगा जब हमें भुगतान जारी करने वाले संस्थान से स्वीकृति और प्राधिकरण कोड प्राप्त होता है। यदि आपका कार्ड जारीकर्ता ऐसा कोई प्राधिकरण नहीं देता है, तो आपके खाते में उन निधियों को जमा नहीं किया जाएगा।'
    },
    {
      class: 't2',
      content: '8.4.आप सेवा के आपके उपयोग के संबंध में हमें या भुगतान प्रदाताओं को देय किसी भी और सभी भुगतानों और शुल्कों का पूरी तरह से भुगतान करने के लिए सहमत हैं। आप यह भी स्वीकार करते हैं कि आप अपनी किसी भी जमा राशि को चार्ज-बैक या त्याग या रद्द या अन्यथा नहीं करेंगे, और ऐसी किसी भी स्थिति में आप हमें ऐसी अवैतनिक जमा राशि वापस कर देंगे और आपकी जमा राशि एकत्र करने की प्रक्रिया में हमारे द्वारा किए गए किसी भी खर्च सहित क्षतिपूर्ति करेंगे। , और आप सहमत हैं कि उन चार्ज बैक फंड्स का उपयोग करने वाले दांव से हुई जीत को जब्त कर लिया जाएगा। आप स्वीकार करते हैं और सहमति देते हैं कि आपका खिलाड़ी खाता एक बैंक खाता नहीं है और इसलिए किसी भी जमा या बैंकिंग बीमा प्रणाली या किसी अन्य अधिकार क्षेत्र की किसी अन्य समान बीमा प्रणाली द्वारा गारंटीकृत, बीमाकृत या अन्यथा संरक्षित नहीं है, जिसमें आपके स्थानीय अधिकार क्षेत्र शामिल हैं लेकिन यह सीमित नहीं है . इसके अलावा, खिलाड़ी के खाते में रखी गई किसी भी धनराशि पर ब्याज नहीं लगता है।'
    },
    {
      class: 't2',
      content: '8.5.यदि आप जमा करने के दौरान बोनस कोड दर्ज करके हमारे किसी प्रचार या बोनस प्रस्ताव को स्वीकार करने का निर्णय लेते हैं, तो आप प्रत्येक विशिष्ट बोनस की शर्तों से सहमत होते हैं।'
    },
    {
      class: 't2',
      content: '8.6.आपराधिक और/या अवैध और/या अनधिकृत गतिविधियों से उत्पन्न धन हमारे पास जमा नहीं किया जाना चाहिए।'
    },
    {
      class: 't2',
      content: '8.7. यदि आप अपने क्रेडिट कार्ड का उपयोग करके जमा करते हैं, तो यह अनुशंसा की जाती है कि आप लेन-देन रिकॉर्ड की एक प्रति और इन शर्तों की एक प्रति अपने पास रखें।'
    },
    {
      class: 't2',
      content: '8.8. जिस अधिकार क्षेत्र में आप स्थित हैं वहां इंटरनेट जुआ अवैध हो सकता है; यदि हां, तो आप इस साइट पर जमा करने के लिए अपने भुगतान कार्ड का उपयोग करने के लिए अधिकृत नहीं हैं। यह आपका उत्तरदायित्व है कि आप अपने अधिवास के देश में ऑनलाइन जुए से संबंधित कानूनों को जानें।'
    },
    {
      class: 't1',
      content: '9.निधियों की निकासी'
    },
    {
      class: 't2',
      content: '9.1. आप हमारी निकासी शर्तों के अनुसार निकासी अनुरोध सबमिट करके अपने खिलाड़ी खाते में रखी किसी भी अप्रयुक्त और समाशोधित धनराशि को वापस ले सकते हैं।'
    },
    {
      class: 't2',
      content: '9.2.मनी लॉन्ड्रिंग से निपटने के लिए हम निकासी शुल्क काटने के हकदार हैं।'
    },
    {
      class: 't2',
      content: '9.3. हम आपके खाते से किसी भी निकासी की अनुमति देने से पहले पहचान सत्यापन के उद्देश्य से फोटो आईडी, पते की पुष्टि या अतिरिक्त सत्यापन प्रक्रियाओं (अपनी सेल्फी का अनुरोध, सत्यापन कॉल की व्यवस्था आदि) करने का अधिकार सुरक्षित रखते हैं। हमारे साथ आपके संबंध के जीवनकाल के दौरान किसी भी समय पहचान सत्यापन करने के हमारे अधिकार भी हमारे पास सुरक्षित हैं।'
    },
    {
      class: 't2',
      content: '9.4.सभी निकासी मूल डेबिट, क्रेडिट कार्ड, बैंक खाते, आपके खाते में भुगतान करने के लिए उपयोग की जाने वाली भुगतान विधि में की जानी चाहिए। हम, और हमेशा अपने विवेक से, आपको उस भुगतान विधि से पैसे निकालने की अनुमति दे सकते हैं जिससे आपकी मूल जमाराशि शुरू नहीं हुई थी। यह हमेशा अतिरिक्त सुरक्षा जांच के अधीन होगा।'
    },
    {
      class: 't2',
      content: '9.5.क्या आप धनराशि निकालना चाहते हैं लेकिन आपका खाता या तो पहुंच से बाहर है, निष्क्रिय है, बंद है या बंद है, कृपया हमारे ग्राहक सेवा विभाग से संपर्क करें।'
    },
    {
      class: 't2',
      content: '9.6.न्यूनतम निकासी राशि 500 INR है। अधिकतम निकासी राशि प्रति लेनदेन 50,000 INR है। प्रति व्यक्ति प्रति दिन 5 निकासी की अनुमति है। कितना निकाला जा सकता है इसकी कोई सीमा नहीं है। यदि सीमा राशि में कोई परिवर्तन अस्थायी रूप से किया गया है तो कृपया हमारे अक्सर पूछे जाने वाले प्रश्नों की समीक्षा करें। '
    },
    {
      class: 't2',
      content: '9.7.कृपया ध्यान दें कि यदि आप खंड 3.3 और 4 में उल्लिखित प्रतिबंधित उपयोग नीति का उल्लंघन करते हैं तो हम निकासी या धनवापसी के सफल प्रसंस्करण की गारंटी नहीं दे सकते।'
    },
    {
      class: 't1',
      content: '10.भुगतान लेनदेन और प्रोसेसर'
    },
    {
      class: 't2',
      content: '10.1.आप हम पर बकाया सभी पैसे का भुगतान करने के लिए पूरी तरह से जिम्मेदार हैं। आपको हमें सभी भुगतान अच्छी नीयत से करना चाहिए और किए गए भुगतान को उलटने का प्रयास नहीं करना चाहिए या ऐसी कोई कार्रवाई नहीं करनी चाहिए जिससे वैध रूप से किए गए दायित्व से बचने के लिए तीसरे पक्ष द्वारा इस तरह के भुगतान को उलट दिया जाए। आप हमें किसी भी चार्ज-बैक, आपके द्वारा किए गए भुगतान के इनकार या उलटने और उसके परिणामस्वरूप हमें हुई किसी भी हानि के लिए प्रतिपूर्ति करेंगे। हम आपके द्वारा किए गए भुगतान के प्रति चार्ज-बैक, इनकार या उलटाव पर प्रशासन शुल्क लगाने का अधिकार भी सुरक्षित रखते हैं।'
    },
    {
      class: 't2',
      content: '10.2.हम आपके द्वारा किए गए भुगतानों को संसाधित करने के लिए तीसरे पक्ष के इलेक्ट्रॉनिक भुगतान प्रोसेसर और या मर्चेंट बैंकों का उपयोग करने का अधिकार सुरक्षित रखते हैं और आप उनके नियमों और शर्तों से बाध्य होने के लिए सहमत हैं, बशर्ते कि वे आपको अवगत कराएं और वे शर्तें इन शर्तों के साथ संघर्ष न करें।'
    },
    {
      class: 't2',
      content: '10.3.मनी लॉन्ड्रिंग या आतंकवाद के वित्तपोषण की गतिविधि को रोकने के लिए हमारी साइट पर किए गए संदिग्ध लेनदेन की जाँच की जाएगी। संदिग्ध लेन-देन की सूचना संबंधित अधिकारी को दी जाएगी।'
    },
    {
      class: 't1',
      content: '11.त्रुटियां'
    },
    {
      class: 't2',
      content: '11.1.हमारे सिस्टम या प्रक्रियाओं में किसी त्रुटि या खराबी की स्थिति में, सभी दांव शून्य हो जाते हैं। सेवा में किसी भी त्रुटि के बारे में पता चलते ही आप हमें तुरंत सूचित करने के लिए बाध्य हैं। सेवा में त्रुटि या त्रुटि के परिणामस्वरूप सेवा और/या आपको किए गए भुगतान के संबंध में संचार या सिस्टम त्रुटियों या बग या वायरस होने की स्थिति में, हम आपके या किसी तीसरे पक्ष के लिए उत्तरदायी नहीं होंगे कोई भी प्रत्यक्ष या अप्रत्यक्ष लागत, व्यय, नुकसान या ऐसी त्रुटियों से उत्पन्न होने वाले या उत्पन्न होने वाले दावे, और हम सभी खेलों/दांवों को रद्द करने का अधिकार सुरक्षित रखते हैं और ऐसी त्रुटियों को ठीक करने के लिए कोई अन्य कार्रवाई करते हैं।'
    },
    {
      class: 't2',
      content: '11.2.हम यह सुनिश्चित करने के लिए हर संभव प्रयास करते हैं कि हम बुकमेकर लाइनों को पोस्ट करने में त्रुटियां न करें। हालाँकि, यदि मानवीय त्रुटि या सिस्टम की समस्याओं के परिणामस्वरूप एक ऑड पर एक बेट स्वीकार की जाती है जो: बेट के समय सामान्य बाजार में उपलब्ध दांव से भौतिक रूप से भिन्न होती है; या स्पष्ट रूप से गलत है जब बेट लगाई गई थी उस समय घटना होने का मौका दिया गया था तो हम उस दांव को रद्द करने या रद्द करने का अधिकार सुरक्षित रखते हैं, या किसी घटना के शुरू होने के बाद किए गए दांव को रद्द या रद्द करने का अधिकार रखते हैं।'
    },
    {
      class: 't2',
      content: '11.3.हमें आपसे अधिक भुगतान की गई किसी भी राशि की वसूली करने और किसी भी गलती को सुधारने के लिए आपके खाते को समायोजित करने का अधिकार है। ऐसी गलती का एक उदाहरण हो सकता है जहां मूल्य गलत है या जहां हम किसी घटना के परिणाम को गलत तरीके से दर्ज करते हैं। यदि आपके खाते में अपर्याप्त धनराशि है, तो हम मांग कर सकते हैं कि आप हमें किसी भी गलत दांव या दांव से संबंधित प्रासंगिक बकाया राशि का भुगतान करें। तदनुसार, हम किसी भी लंबित नाटकों को रद्द करने, कम करने या हटाने का अधिकार सुरक्षित रखते हैं, चाहे त्रुटि के परिणामस्वरूप धन के साथ रखा गया हो या नहीं।'
    },
    {
      class: 't1',
      content: '12. खेल, धन-वापसी और रद्द करने के नियम'
    },
    {
      class: 't2',
      content: '12.1.किसी घटना के विजेता का निर्धारण घटना के निपटारे की तिथि पर किया जाएगा, और हम दांव लगाने के उद्देश्यों के लिए विरोध किए गए या पलटे हुए निर्णयों को मान्यता नहीं देंगे।'
    },
    {
      class: 't2',
      content: '12.2.पोस्ट किए गए सभी परिणाम 72 घंटों के बाद अंतिम होंगे और उस अवधि के बाद किसी भी प्रश्न पर विचार नहीं किया जाएगा। परिणाम पोस्ट किए जाने के 72 घंटों के भीतर, हम केवल मानवीय त्रुटि, सिस्टम त्रुटि या रेफ़रिंग परिणाम स्रोत द्वारा की गई गलतियों के कारण परिणामों को रीसेट/सही करेंगे।'
    },
    {
      class: 't2',
      content: '12.3.अगर पेआउट अवधि के भीतर मैच के शासी निकाय द्वारा किसी भी कारण से मैच का परिणाम पलट दिया जाता है तो सभी पैसे वापस कर दिए जाएंगे।'
    },
    {
      class: 't2',
      content: '12.4.यदि एक ऐसे खेल में ड्रॉ होता है जहां ड्रॉ विकल्प की पेशकश की जाती है तो टीम की जीत या हार पर सभी दांव हार जाएंगे। यदि ड्रा विकल्प की पेशकश नहीं की जाती है, तो मैच के ड्रा के परिणाम में सभी को रिफंड मिलता है। और यदि ड्रॉ का विकल्प उपलब्ध नहीं कराया गया है, तो यदि खेला जाता है तो अतिरिक्त समय गिना जाएगा।'
    },
    {
      class: 't2',
      content: '12.5.यदि कोई परिणाम हमारे द्वारा मान्य नहीं किया जा सकता है, उदाहरण के लिए यदि ईवेंट को प्रसारित करने वाली फ़ीड बाधित होती है (और किसी अन्य स्रोत द्वारा सत्यापित नहीं की जा सकती है) तो हमारे चुनाव में, उस ईवेंट पर दांव को अमान्य माना जाएगा और दांव वापस कर दिया जाएगा।'
    },
    {
      class: 't2',
      content: '12.6.सभी घटनाओं पर न्यूनतम और अधिकतम दांव राशि हमारे द्वारा निर्धारित की जाएगी और पूर्व लिखित सूचना के बिना परिवर्तन के अधीन हैं। हम व्यक्तिगत खातों की सीमाओं को भी समायोजित करने का अधिकार सुरक्षित रखते हैं।'
    },
    {
      class: 't2',
      content: '12.7. ग्राहक अपने खाते के लेन-देन के लिए पूरी तरह से जिम्मेदार हैं। एक बार लेन-देन पूरा हो जाने के बाद, इसे बदला नहीं जा सकता। हम ग्राहक द्वारा किए गए लापता या डुप्लिकेट दांव के लिए जिम्मेदारी नहीं लेते हैं और विसंगति के अनुरोधों पर विचार नहीं करेंगे क्योंकि एक नाटक गुम या डुप्लिकेट है। ग्राहक प्रत्येक सत्र के बाद साइट के मेरा खाता अनुभाग में अपने लेन-देन की समीक्षा कर सकते हैं ताकि यह सुनिश्चित हो सके कि सभी अनुरोधित दांव स्वीकार किए गए हैं।'
    },
    {
      class: 't2',
      content: '12.8.एक मैचअप में तब तक कार्रवाई होगी जब तक कि दो टीमें सही हैं, और लीग हेडर की परवाह किए बिना जिसमें यह हमारी वेबसाइट पर रखा गया है।'
    },
    {
      class: 't2',
      content: '12.9.स्पोर्ट मैचों के लिए वेबसाइट पर प्रदर्शित प्रारंभ दिनांक और समय केवल एक संकेत हैं और इसके सही होने की गारंटी नहीं है। यदि कोई मैच निलंबित या स्थगित कर दिया जाता है, और वास्तविक निर्धारित प्रारंभ समय से 72 घंटों के भीतर फिर से शुरू नहीं किया जाता है, तो मैच में कोई कार्रवाई नहीं होगी और दांव वापस कर दिए जाएंगे। एक टीम/खिलाड़ी किसी टूर्नामेंट में आगे बढ़ता है या टूर्नामेंट जीतता है, इस पर कोई भी दांव अपवाद है, निलंबित या स्थगित मैच की परवाह किए बिना कार्रवाई होगी।'
    },
    {
      class: 't2',
      content: '12.10. यदि हमारे द्वारा गलत तिथि के साथ कोई घटना पोस्ट की जाती है, तो सभी दांव शासी निकाय द्वारा घोषित तिथि के आधार पर कार्रवाई करते हैं।'
    },
    {
      class: 't2',
      content: '12.11.यदि कोई टीम स्टैंड-इन का उपयोग कर रही है, तो परिणाम अभी भी मान्य है क्योंकि यह स्टैंड-इन का उपयोग करने के लिए टीम की पसंद थी।'
    },
    {
      class: 't2',
      content: '12.12.कंपनी वेबसाइट से घटनाओं, बाजारों और किसी भी अन्य उत्पादों को हटाने का अधिकार सुरक्षित रखती है।'
    },
    {
      class: 't1',
      content: '13.संचार और नोटिस'
    },
    {
      class: 't2',
      content: '13.1.इन शर्तों के तहत आपके द्वारा हमें दिए जाने वाले सभी संचार और नोटिस वेबसाइट पर ग्राहक सहायता ईमेल का उपयोग करके भेजे जाएंगे।'
    },
    {
      class: 't2',
      content: '13.2.इन शर्तों के तहत हमारे द्वारा आपको दिए जाने वाले सभी संचार और नोटिस, जब तक कि इन शर्तों में अन्यथा निर्दिष्ट न किया गया हो, या तो वेबसाइट पर पोस्ट किया जाएगा और/या संबंधित ग्राहक के लिए हमारे सिस्टम पर मौजूद पंजीकृत ईमेल पते पर भेजा जाएगा। इस तरह के संचार का तरीका हमारे एकमात्र और अनन्य विवेक पर होगा।'
    },
    {
      class: 't2',
      content: '13.3.इन शर्तों के तहत आपके या हमारे द्वारा दिए जाने वाले सभी संचार और नोटिस अंग्रेजी भाषा में लिखित रूप में होंगे और आपके खाते में पंजीकृत ईमेल पते पर दिए जाने चाहिए।'
    },
    {
      class: 't2',
      content: '13.4.समय-समय पर, हम आपको सट्टेबाजी के बारे में जानकारी देने, अद्वितीय प्रचार प्रस्तावों और PGEBet से अन्य जानकारी प्रदान करने के उद्देश्य से ईमेल द्वारा आपसे संपर्क कर सकते हैं। जब आप वेबसाइट पर पंजीकरण करते समय इन शर्तों से सहमत होते हैं तो आप ऐसे ईमेल प्राप्त करने के लिए सहमत होते हैं। आप किसी भी समय ग्राहक सहायता को अनुरोध सबमिट करके हमसे इस तरह के प्रचार प्रस्ताव प्राप्त करने का विकल्प चुन सकते हैं।'
    },
    {
      class: 't1',
      content: '14.हमारे नियंत्रण से परे मामले'
    },
    {
      class: 't2',
      content: 'अप्रत्याशित घटना की घटना के कारण सेवा प्रदान करने में किसी भी विफलता या देरी के लिए हमें उत्तरदायी नहीं ठहराया जा सकता है, जिसे हमारे उचित निवारक उपायों के निष्पादन के बावजूद यथोचित रूप से हमारे नियंत्रण से बाहर माना जा सकता है जैसे: ईश्वर का कार्य; व्यापार या श्रम विवाद; बिजली कटौती; किसी भी सरकार या प्राधिकरण का कार्य, विफलता या चूक; दूरसंचार सेवाओं में बाधा या विफलता; या किसी तीसरे पक्ष की वजह से हुई कोई अन्य देरी या विफलता, और हम किसी भी परिणामी हानि या क्षति के लिए उत्तरदायी नहीं होंगे जो आपको भुगतनी पड़ सकती है। ऐसी स्थिति में, हम बिना किसी दायित्व के सेवा को रद्द या निलंबित करने का अधिकार सुरक्षित रखते हैं।'
    },
    {
      class: 't1',
      content: '15.देयता'
    },
    {
      class: 't2',
      content: '15.1. लागू कानून द्वारा अनुमत सीमा तक, हम आपको किसी भी यथोचित पूर्वाभास योग्य हानि या क्षति (या तो प्रत्यक्ष या अप्रत्यक्ष) के लिए क्षतिपूर्ति नहीं करेंगे, यदि हम इन शर्तों के तहत अपने दायित्वों को पूरा करने में विफल रहते हैं, जब तक कि हम कानून द्वारा हम पर लगाए गए किसी भी कर्तव्य का उल्लंघन नहीं करते हैं (इसमें शामिल है कि अगर हम अपनी लापरवाही से मौत या व्यक्तिगत चोट का कारण बनते हैं) इस मामले में हम आपके लिए उत्तरदायी नहीं होंगे यदि उस विफलता के लिए जिम्मेदार है: (I) आपकी अपनी गलती; (II) एक तीसरा पक्ष इन शर्तों के हमारे प्रदर्शन से जुड़ा नहीं है (उदाहरण के लिए संचार नेटवर्क के प्रदर्शन, भीड़भाड़ और कनेक्टिविटी या आपके कंप्यूटर उपकरणों के प्रदर्शन के कारण समस्याएं); या (III) कोई अन्य घटना जिसका न तो हम और न ही हमारे आपूर्तिकर्ता पूर्वाभास कर सकते थे या रोक सकते थे, भले ही हमने या उन्होंने उचित देखभाल की हो। चूंकि यह सेवा केवल उपभोक्ता उपयोग के लिए है, हम किसी भी प्रकार के किसी भी व्यावसायिक नुकसान के लिए उत्तरदायी नहीं होंगे।'
    },
    {
      class: 't2',
      content: '15.2.ऐसी स्थिति में जब हम इन शर्तों के तहत किसी भी घटना के लिए उत्तरदायी ठहराए जाते हैं, इन शर्तों के तहत या इसके संबंध में आपके प्रति हमारी कुल देयता (ए) से अधिक नहीं होगी (ए) आपके खाते के संबंध में आपके द्वारा लगाए गए दांव और दांव का मूल्य प्रासंगिक शर्त/दांव या उत्पाद जिसने प्रासंगिक देयता को जन्म दिया, या (बी) कुल मिलाकर 40,000 रुपये, जो भी कम हो।'
    },
    {
      class: 't2',
      content: '15.3. हम दृढ़ता से अनुशंसा करते हैं कि आप (I) उपयोग करने से पहले अपने स्वयं के कंप्यूटर उपकरण के साथ सेवा की उपयुक्तता और संगतता को सत्यापित करने का ध्यान रखें; और (II) एंटी-वायरस सॉफ़्टवेयर की स्थापना सहित हानिकारक कार्यक्रमों या उपकरणों से स्वयं को बचाने के लिए उचित सावधानी बरतें।'
    },
    {
      class: 't1',
      content: '16.कम उम्र के लोगों द्वारा जुआ'
    },
    {
      class: 't2',
      content: '16.1.यदि हमें संदेह है कि आप हैं या सूचना प्राप्त करते हैं कि आप वर्तमान में 18 वर्ष से कम आयु के हैं या 18 वर्ष से कम (या आपके लिए लागू अधिकार क्षेत्र के कानूनों में निर्धारित वयस्कता की आयु से कम) हैं, जब आपने अपने खाते की सेवा के माध्यम से कोई दांव लगाया था आपको आगे कोई दांव लगाने या अपने खाते से कोई निकासी करने से रोकने के लिए निलंबित (लॉक) कर दिया जाएगा। फिर हम इस मामले की जांच करेंगे, जिसमें यह भी शामिल है कि क्या आप 18 साल से कम उम्र के व्यक्ति (या आप पर लागू अधिकार क्षेत्र के कानूनों में निर्धारित वयस्कता से कम उम्र) के लिए एक एजेंट के रूप में सट्टेबाजी कर रहे हैं, या अन्यथा उसकी ओर से। यदि यह पाया गया है कि आप: (ए) वर्तमान में हैं; (बी) 18 वर्ष से कम या उस बहुमत से कम उम्र के थे जो प्रासंगिक समय पर आप पर लागू होता है; या (सी) 18 वर्ष या उससे कम आयु के व्यक्ति के लिए या उसके इशारे पर एक एजेंट के रूप में सट्टेबाजी कर रहा है जो लागू होता है:'
    },
    {
      class: 't2',
      content: '<i style="margin-left: 20px;">●&nbsp;</i>वर्तमान में या आपके खाते में जमा होने वाली सभी जीत बरकरार रहेंगी;'
    },
    {
      class: 't2',
      content: '<i style="margin-left: 20px;">●&nbsp;</i>कम उम्र के दौरान सेवा के माध्यम से सट्टेबाजी से प्राप्त सभी जीत का भुगतान हमें मांग पर किया जाना चाहिए (यदि आप इस प्रावधान का पालन करने में विफल रहते हैं) हम ऐसी राशियों की वसूली से जुड़ी सभी लागतों को वसूल करने का प्रयास करेंगे); और/या'
    },
    {
      class: 't2',
      content: '<i style="margin-left: 20px;">●&nbsp;</i>आपके खाते में जमा की गई कोई भी धनराशि जो जीत नहीं रही है, आपको वापस कर दी जाएगी या हमारे पूर्ण विवेकाधिकार पर आपके 18 वर्ष के होने तक आपके पास रखी जाएगी। . हम वापसी की जाने वाली राशि से भुगतान लेनदेन शुल्क काटने का अधिकार सुरक्षित रखते हैं, जिसमें आपके PGEBet खाते में जमा राशि के लिए लेनदेन शुल्क शामिल है, जिसे हमने कवर किया है।'
    },
    {
      class: 't2',
      content: '16.2.यह शर्त आप पर भी लागू होती है यदि आपकी आयु 18 वर्ष से अधिक है लेकिन आप अपना दांव एक अधिकार क्षेत्र के भीतर लगा रहे हैं जो कानूनी सट्टेबाजी के लिए 18 वर्ष से अधिक आयु निर्दिष्ट करता है और आप उस अधिकार क्षेत्र में कानूनी न्यूनतम आयु से कम हैं।'
    },
    {
      class: 't2',
      content: '16.3.ऐसी स्थिति में जब हमें संदेह होता है कि आप इस खंड के प्रावधानों का उल्लंघन कर रहे हैं या धोखाधड़ी के उद्देश्य से उन पर भरोसा करने का प्रयास कर रहे हैं, तो हम संबंधित कानून प्रवर्तन एजेंसियों को सूचित करने सहित मामले की जांच के लिए आवश्यक कार्रवाई करने का अधिकार सुरक्षित रखते हैं।'
    },
    {
      class: 't1',
      content: '17.धोखा'
    },
    {
      class: 't2',
      content: 'हम धोखाधड़ी, बेईमानी या आपराधिक कृत्यों में शामिल किसी भी ग्राहक के खिलाफ आपराधिक और संविदात्मक प्रतिबंधों की मांग करेंगे। हम ऐसे किसी भी ग्राहक का भुगतान रोक देंगे जहां इनमें से किसी का भी संदेह होगा। ग्राहक क्षतिपूर्ति करेगा और हमारे द्वारा किए गए सभी लागतों, शुल्कों या हानियों (किसी भी प्रत्यक्ष, अप्रत्यक्ष या परिणामी नुकसान, लाभ की हानि, व्यवसाय की हानि और प्रतिष्ठा की हानि सहित) की मांग पर भुगतान करने के लिए उत्तरदायी होगा। अप्रत्यक्ष रूप से ग्राहक की धोखाधड़ी, बेईमानी या आपराधिक कृत्य से।'
    },
    {
      class: 't1',
      content: '18.बौद्धिक संपदा'
    },
    {
      class: 't2',
      content: '18.1.हमारे नाम और लोगो के किसी भी अनधिकृत उपयोग के परिणामस्वरूप आपके खिलाफ कानूनी कार्रवाई की जा सकती है।'
    },
    {
      class: 't2',
      content: '18.2.हमारे और आपके बीच, हम सेवा, हमारी तकनीक, सॉफ्टवेयर और व्यापार प्रणालियों ("सिस्टम") के साथ-साथ हमारी बाधाओं के अधिकारों के एकमात्र स्वामी हैं। आपको अपने स्वयं के व्यावसायिक लाभ के लिए अपनी व्यक्तिगत प्रोफ़ाइल का उपयोग नहीं करना चाहिए (जैसे किसी विज्ञापनदाता को अपना स्टेटस अपडेट बेचना); और आपके खाते के लिए एक प्रचलित नाम का चयन करते समय हम इसे उचित मानने पर इसे हटाने या पुनः दावा करने का अधिकार सुरक्षित रखते हैं।'
    },
    {
      class: 't2',
      content: '18.3.आप हमारे URL, ट्रेडमार्क, ट्रेड नाम और/या ट्रेड ड्रेस, लोगो (“मार्क्स”) और/या किसी भी उत्पाद या सेवा के संबंध में हमारे ऑड्स का उपयोग नहीं कर सकते हैं, जो कि हमारा नहीं है, जो किसी भी तरह से लोगों के बीच भ्रम पैदा करने की संभावना है। ग्राहक या सार्वजनिक रूप से या जो किसी भी तरह से हमें नापसंद करता है।'
    },
    {
      class: 't2',
      content: '18.4.इन शर्तों में स्पष्ट रूप से प्रदान किए जाने के अलावा, हम और हमारे लाइसेंसकर्ता आपको कोई व्यक्त या निहित अधिकार, लाइसेंस, शीर्षक या सिस्टम या मार्क्स और ऐसे सभी अधिकार, लाइसेंस, शीर्षक और हित प्रदान नहीं करते हैं जो विशेष रूप से हमारे द्वारा बनाए गए हैं और हमारे लाइसेंसकर्ता। आप सेवा के भीतर वेब पेजों या सामग्री की निगरानी या कॉपी करने के लिए किसी स्वचालित या मैन्युअल डिवाइस का उपयोग नहीं करने के लिए सहमत हैं। किसी भी अनधिकृत उपयोग या पुनरुत्पादन के परिणामस्वरूप आपके विरुद्ध कानूनी कार्रवाई की जा सकती है।'
    },
    {
      class: 't1',
      content: '19.आपका लाइसेंस'
    },
    {
      class: 't2',
      content: '19.1.इन शर्तों और उनके साथ आपके अनुपालन के अधीन, हम आपको केवल आपके व्यक्तिगत गैर-वाणिज्यिक उद्देश्यों के लिए सेवा तक पहुंचने और उपयोग करने के लिए एक गैर-अनन्य, सीमित, गैर-हस्तांतरणीय और गैर-लाइसेंस योग्य लाइसेंस प्रदान करते हैं। यदि इन शर्तों के तहत आपके साथ हमारा अनुबंध समाप्त हो जाता है तो हमारा लाइसेंस समाप्त हो जाता है।'
    },
    {
      class: 't2',
      content: '19.2.अपनी स्वयं की सामग्री के संबंध में सहेजें, आप किसी भी परिस्थिति में सेवा को संशोधित, प्रकाशित, संचारित, स्थानांतरित, बेचना, पुन: प्रस्तुत करना, अपलोड करना, पोस्ट करना, वितरित करना, प्रदर्शन करना, प्रदर्शित करना, व्युत्पन्न कार्य बनाना या किसी अन्य तरीके से शोषण नहीं कर सकते हैं। और/या उसमें मौजूद कोई भी सामग्री या उसमें निहित सॉफ़्टवेयर, सिवाय इसके कि हम इन शर्तों में या अन्यथा वेबसाइट पर स्पष्ट रूप से अनुमति देते हैं। सेवा पर कोई जानकारी या सामग्री या सेवा के संबंध में आपको उपलब्ध कराई गई सामग्री को संशोधित या परिवर्तित नहीं किया जा सकता है, अन्य डेटा के साथ विलय किया जा सकता है या किसी भी रूप में प्रकाशित किया जा सकता है, उदाहरण के लिए स्क्रीन या डेटाबेस स्क्रैपिंग और एकत्र करने, स्टोर करने, पुनर्गठित करने के उद्देश्य से कोई अन्य गतिविधि या ऐसी जानकारी या सामग्री में हेरफेर करें।'
    },
    {
      class: 't2',
      content: '19.3.इस खंड का आपके द्वारा कोई भी गैर-अनुपालन हमारे या तीसरे पक्ष की बौद्धिक संपदा और अन्य स्वामित्व अधिकारों का उल्लंघन भी हो सकता है, जो आपको नागरिक दायित्व और/या आपराधिक अभियोजन के अधीन कर सकता है।'
    },
    {
      class: 't1',
      content: '20.आपका आचरण और सुरक्षा'
    },
    {
      class: 't2',
      content: '20.1.आपकी सुरक्षा और हमारे सभी ग्राहकों की सुरक्षा के लिए, सेवा पर किसी भी सामग्री को पोस्ट करने के साथ-साथ उससे संबंधित आचरण और/या सेवा, जो किसी भी तरह से गैरकानूनी, अनुचित या अवांछनीय है, सख्त वर्जित है ("निषिद्ध व्यवहार")'
    },
    {
      class: 't2',
      content: '20.2.यदि आप निषिद्ध व्यवहार में संलग्न हैं, या हम अपने विवेकाधिकार से यह निर्धारित करते हैं कि आप निषिद्ध व्यवहार में संलग्न हैं, तो आपका खाता और/या सेवा तक आपकी पहुंच या उपयोग आपको नोटिस दिए बिना तुरंत समाप्त किया जा सकता है। आपके खिलाफ किसी अन्य ग्राहक, अन्य तीसरे पक्ष, प्रवर्तन अधिकारियों और/या हमारे द्वारा निषिद्ध व्यवहार में शामिल होने के संबंध में कानूनी कार्रवाई की जा सकती है।'
    },
    {
      class: 't2',
      content: '20.3.प्रतिबंधित व्यवहार में निम्न के लिए सेवा तक पहुँचना या उसका उपयोग करना शामिल है, लेकिन यह इन्हीं तक सीमित नहीं है:'
    },
    {
      class: 't2',
      content: 'जानकारी को बढ़ावा देना या साझा करना जो आप जानते हैं कि गलत, भ्रामक या गैरकानूनी है;'
    },
    {
      class: 't2',
      content: 'किसी भी गैरकानूनी या अवैध गतिविधि का संचालन करें, जैसे कि, लेकिन किसी भी गतिविधि तक सीमित नहीं है, जो किसी भी आपराधिक गतिविधि या उद्यम को बढ़ावा देती है या बढ़ावा देती है, किसी अन्य ग्राहक या किसी अन्य तीसरे पक्ष की गोपनीयता या अन्य अधिकारों का उल्लंघन करती है या जो बनाता है या फैलता है कम्प्यूटर वायरस;'
    },
    {
      class: 't2',
      content: 'नाबालिगों को किसी भी तरह से नुकसान पहुंचाता है;'
    },
    {
      class: 't2',
      content: 'कोई भी ऐसी सामग्री प्रसारित या उपलब्ध कराएं जो गैरकानूनी, हानिकारक, धमकी देने वाली, अपमानजनक, कपटपूर्ण, मानहानिकारक, अश्लील, अश्लील, भद्दी, हिंसक, घृणित, या नस्लीय या जातीय या अन्यथा आपत्तिजनक हो;'
    },
    {
      class: 't2',
      content: 'किसी भी ऐसी सामग्री को प्रसारित या उपलब्ध कराना जिसे उपयोगकर्ता के पास किसी कानून या संविदात्मक या प्रत्ययी संबंध के तहत उपलब्ध कराने का अधिकार नहीं है, जिसमें बिना किसी सीमा के, कोई भी सामग्री जो किसी तीसरे पक्ष के कॉपीराइट, ट्रेडमार्क या अन्य बौद्धिक संपदा और मालिकाना अधिकारों का उल्लंघन करती है ;'
    },
    {
      class: 't2',
      content: 'सेवा, इसकी प्रस्तुति या किसी अन्य वेबसाइट, कंप्यूटर सॉफ्टवेयर या हार्डवेयर की कार्यक्षमता को बाधित करने, नष्ट करने या बदलने के लिए डिज़ाइन किया गया कोई भी सॉफ़्टवेयर वायरस या अन्य कंप्यूटर या प्रोग्रामिंग कोड (HTML सहित) वाली कोई भी सामग्री या सामग्री प्रसारित या उपलब्ध कराना ;'
    },
    {
      class: 't2',
      content: 'किसी भी तरीके से सेवा में हस्तक्षेप, बाधित या रिवर्स इंजीनियर, जिसमें बिना किसी सीमा के, हमारे द्वारा उपयोग किए जाने वाले संचार प्रोटोकॉल को इंटरसेप्ट करना, अनुकरण करना या पुनर्निर्देशित करना, धोखा, मॉड या हैक या सेवा को संशोधित करने के लिए डिज़ाइन किया गया कोई अन्य सॉफ़्टवेयर बनाना या उपयोग करना शामिल है। , या किसी ऐसे सॉफ़्टवेयर का उपयोग करना जो सेवा से या उसके माध्यम से जानकारी को रोकता है या एकत्र करता है;'
    },
    {
      class: 't2',
      content: 'किसी भी रोबोट, स्पाइडर या अन्य स्वचालित तंत्र का उपयोग करके सेवा से किसी भी जानकारी को पुनर्प्राप्त या अनुक्रमित करें;'
    },
    {
      class: 't2',
      content: 'किसी भी गतिविधि या कार्रवाई में भाग लेना, जो हमारे एकमात्र और संपूर्ण स्वतंत्र विवेक के परिणामस्वरूप होता है या जिसके परिणामस्वरूप किसी अन्य ग्राहक को धोखा दिया जा सकता है या धोखा दिया जा सकता है;'
    },
    {
      class: 't2',
      content: 'किसी भी अवांछित या अनधिकृत विज्ञापन या सामूहिक मेलिंग को प्रसारित या उपलब्ध कराएं, जैसे कि जंक मेल, त्वरित संदेश, "स्पैम", श्रृंखला पत्र, पिरामिड स्कीम या अनुरोध के अन्य रूप;'
    },
    {
      class: 't2',
      content: 'वेबसाइट पर स्वचालित तरीकों से या झूठे या धोखाधड़ी के बहाने से खाते बनाएँ;'
    },
    {
      class: 't2',
      content: 'किसी अन्य ग्राहक या किसी अन्य तृतीय पक्ष का प्रतिरूपण करें, या'
    },
    {
      class: 't2',
      content: 'कोई अन्य कार्य या किया गया काम जिसे हम यथोचित रूप से अपने व्यावसायिक सिद्धांतों के विपरीत मानते हैं।'
    },
    {
      class: 't2',
      content: 'निषेध व्यवहार की उपरोक्त सूची संपूर्ण नहीं है और हमारे द्वारा किसी भी समय या समय-समय पर संशोधित की जा सकती है। हम जांच करने का अधिकार सुरक्षित रखते हैं और ऐसी सभी कार्रवाइयां करने का अधिकार सुरक्षित रखते हैं, जैसा कि हम अपने विवेकाधिकार से परिस्थितियों में उपयुक्त या आवश्यक समझते हैं, जिसमें बिना किसी सीमा के ग्राहक की पोस्टिंग को सेवा से हटाना और/या उनके खाते को समाप्त करना और कोई कार्रवाई करना शामिल है। किसी भी ग्राहक या तीसरे पक्ष के खिलाफ जो प्रत्यक्ष या अप्रत्यक्ष रूप से, या'
    },
    {
      class: 't2',
      content: 'जानबूझकर किसी तीसरे पक्ष को सीधे या परोक्ष रूप से निषिद्ध व्यवहार में शामिल होने की अनुमति देता है, ऐसे ग्राहक या तीसरे पक्ष को नोटिस के साथ या बिना।'
    },
    {
      class: 't1',
      content: '21.अन्य वेब साइटों के लिंक'
    },
    {
      class: 't2',
      content: 'सेवा में तीसरे पक्ष की वेबसाइटों के लिंक हो सकते हैं जो हमारे द्वारा बनाए नहीं जाते हैं, या उनसे संबंधित नहीं हैं, और जिन पर हमारा कोई नियंत्रण नहीं है। ऐसी वेबसाइटों के लिंक केवल ग्राहकों की सुविधा के लिए प्रदान किए जाते हैं, और हमारे द्वारा सटीकता या पूर्णता के लिए किसी भी तरह से जांच, निगरानी या जाँच नहीं की जाती है। ऐसी वेबसाइटों के लिंक हमारे द्वारा लिंक की गई वेबसाइटों या उनकी सामग्री या उनके स्वामी (स्वामियों) के किसी भी समर्थन, और/या किसी भी संबद्धता का संकेत नहीं देते हैं। उपलब्धता और न ही उनकी सटीकता, पूर्णता, पहुंच और उपयोगिता के लिए हमारा कोई नियंत्रण या जिम्मेदारी नहीं है। तदनुसार ऐसी वेबसाइटों तक पहुँचने पर हम अनुशंसा करते हैं कि आपको किसी नई वेबसाइट पर जाते समय उनकी गोपनीयता नीति और उपयोग की शर्तों की समीक्षा करने सहित सामान्य सावधानी बरतनी चाहिए।'
    },
    {
      class: 't1',
      content: '22.शिकायतें'
    },
    {
      class: 't2',
      content: '22.1.यदि आपको इन शर्तों के बारे में कोई चिंता या प्रश्न हैं, तो आपको वेबसाइट पर लिंक के माध्यम से हमारे ग्राहक सेवा विभाग से संपर्क करना चाहिए और हमारे साथ सभी संचार में अपने पंजीकृत ईमेल पते का उपयोग करना चाहिए।'
    },
    {
      class: 't2',
      content: '22.2. पूर्वगामी के बावजूद, हम किसी भी शिकायत का जवाब देते समय आपके या किसी भी तीसरे पक्ष के प्रति कोई उत्तरदायित्व नहीं लेते हैं, जो हमें प्राप्त हुआ है या उसके संबंध में कार्रवाई की है।'
    },
    {
      class: 't2',
      content: '22.3.यदि कोई ग्राहक इस बात से संतुष्ट नहीं है कि बेट कैसे तय की गई है, तो ग्राहक को अपनी शिकायत का विवरण हमारे ग्राहक सेवा विभाग को प्रदान करना चाहिए। हम कुछ दिनों के भीतर इस प्रकार के प्रश्नों का जवाब देने के लिए अपने उचित प्रयासों का उपयोग करेंगे (और किसी भी सूरत में हम ऐसे सभी प्रश्नों का उत्तर प्राप्ति के 24 घंटे के भीतर देना चाहते हैं)।'
    },
    {
      class: 't2',
      content: '22.4.विवादित दांव का निर्णय होने की तारीख से तीन (3) दिनों के भीतर विवाद दर्ज किया जाना चाहिए। इस अवधि के बाद कोई दावा स्वीकार नहीं किया जाएगा। ग्राहक अपने खाते के लेन-देन के लिए पूरी तरह से जिम्मेदार है।'
    },
    {
      class: 't2',
      content: '22.5.आपके और हमारे बीच विवाद उत्पन्न होने की स्थिति में हमारा ग्राहक सेवा विभाग एक सहमत समाधान तक पहुँचने का प्रयास करेगा। यदि हमारा ग्राहक सेवा विभाग आपके साथ किसी सहमत समाधान तक पहुँचने में असमर्थ होता है, तो मामला हमारे प्रबंधन के पास भेज दिया जाएगा।'
    },
    {
      class: 't1',
      content: '23.कार्यभार'
    },
    {
      class: 't2',
      content: 'न तो ये शर्तें और न ही इसके तहत कोई भी अधिकार या दायित्व आपके द्वारा हमारी पूर्व लिखित सहमति के बिना निर्दिष्ट किए जा सकते हैं, जो सहमति अनुचित रूप से रोकी नहीं जाएगी। हम आपकी सहमति के बिना, हमारे अधिकारों और दायित्वों के सभी या किसी भी हिस्से को किसी तीसरे पक्ष को सौंप सकते हैं, बशर्ते कि ऐसा तीसरा पक्ष सेवा पर इस आशय का लिखित नोटिस पोस्ट करके सेवा के समान गुणवत्ता वाली सेवा प्रदान करने में सक्षम हो।'
    },
    {
      class: 't1',
      content: '24.पृथक्करणीयता'
    },
    {
      class: 't2',
      content: 'इस घटना में कि इन शर्तों के किसी भी प्रावधान को किसी भी सक्षम प्राधिकारी द्वारा अप्रवर्तनीय या अमान्य माना जाता है, प्रासंगिक प्रावधान को मूल पाठ के इरादे के अनुरूप लागू करने की अनुमति देने के लिए इसे पूरी तरह से अनुमति देने के लिए संशोधित किया जाएगा। लागू कानून द्वारा। इन शर्तों के शेष प्रावधानों की वैधता और प्रवर्तनीयता प्रभावित नहीं होगी'
    },
    {
      class: 't1',
      content: '25.इन शर्तों का उल्लंघन'
    },
    {
      class: 't2',
      content: 'हमारे अन्य उपचारों को सीमित किए बिना, हम आपके खाते को निलंबित या समाप्त कर सकते हैं और आपको सेवा प्रदान करने के लिए जारी रखने से इंकार कर सकते हैं, किसी भी मामले में आपको पूर्व सूचना दिए बिना, यदि हमारी उचित राय में, आप इनमें से किसी भी महत्वपूर्ण शर्त का उल्लंघन करते हैं शर्तें। हालांकि, इस तरह की किसी भी कार्रवाई की सूचना आपको तुरंत प्रदान की जाएगी।'
    },
    {
      class: 't1',
      content: '26.सामान्य प्रावधान'
    },
    {
      class: 't2',
      content: '26.1.समझौते की अवधि। जब आप सेवा का उपयोग या उपयोग करते हैं या वेबसाइट के ग्राहक या आगंतुक होते हैं तो ये शर्तें पूरी तरह से लागू और प्रभावी रहेंगी। ये शर्तें किसी भी कारण से आपके खाते की समाप्ति के बाद भी बनी रहेंगी।'
    },
    {
      class: 't2',
      content: '26.2.लिंग। एकवचन को दर्शाने वाले शब्दों में बहुवचन और विलोमतः शामिल होंगे, पुल्लिंग को शामिल करने वाले शब्दों में स्त्रीलिंग और नपुंसक लिंग को शामिल किया जाएगा और इसके विपरीत और व्यक्तियों को आयात करने वाले शब्दों में व्यक्ति, भागीदारी, संघ, ट्रस्ट, अनिगमित संगठन और निगम शामिल होंगे।'
    },
    {
      class: 't2',
      content: '26.3.छूट। हमारे द्वारा कोई भी छूट, चाहे आचरण द्वारा या अन्यथा, आपके द्वारा इन शर्तों के किसी भी नियम या शर्त के उल्लंघन या धमकी के उल्लंघन के खिलाफ प्रभावी होगी, या हमारे लिए बाध्यकारी होगी, जब तक कि लिखित रूप में और हमारे द्वारा विधिवत हस्ताक्षरित न हो, और, जब तक अन्यथा लिखित छूट में प्रदान किया गया, विशिष्ट उल्लंघन छूट तक ही सीमित होगा। किसी भी समय इन शर्तों के किसी भी नियम या शर्त को लागू करने में हमारी विफलता को इस तरह के प्रावधान की छूट या किसी अन्य समय में इस तरह के प्रावधान को लागू करने के हमारे अधिकार के रूप में नहीं माना जाएगा।'
    },
    {
      class: 't2',
      content: '26.4. स्वीकृति। इसके बाद सेवा तक पहुँचने या उपयोग करने से, आप इन शर्तों के प्रत्येक पैराग्राफ को पढ़ने, समझने और सहमत होने की पुष्टि करते हैं। परिणामस्वरूप, आप इन शर्तों में निहित किसी भी चीज़ के विपरीत किसी भी भविष्य के तर्क, दावे, मांग या कार्यवाही को अपरिवर्तनीय रूप से माफ करते हैं।'
    },
    {
      class: 't2',
      content: '26.5.भाषा। इन नियमों के अंग्रेजी भाषा के संस्करण और किसी अन्य भाषा के संस्करण के बीच कोई विसंगति होने की स्थिति में, अंग्रेजी भाषा के संस्करण को सही माना जाएगा।'
    },
    {
      class: 't2',
      content: '26.6.शासी कानून। ये शर्तें कुराकाओ में लागू कानून द्वारा शासित हैं।'
    },
    {
      class: 't2',
      content: '26.7.पूरे समझौते। ये शर्तें सेवा तक आपकी पहुंच और उपयोग के संबंध में आपके और हमारे बीच संपूर्ण अनुबंध का निर्माण करती हैं, और अन्य सभी पूर्व अनुबंधों और संचारों का अधिक्रमण करती हैं, चाहे मौखिक हो या इसके विषय के संबंध में लिखित।'
    }
  ],
  faqList: [
    {
      key: 'common',
      label: 'सबसे सामान्य प्रश्न'
    },
    {
      key: 'deposit',
      label: 'जमा'
    },
    {
      key: 'withdraw',
      label: 'निकासी'
    },
    {
      key: 'account',
      label: 'खाता'
    },
    // {
    //   key: 'बोनस',
    //   label: 'बोनस'
    // },
    {
      key: 'wagering',
      label: 'दांव संबंधी आवश्यकताएं'
    },
    {
      key: 'support',
      label: 'तकनीकी सहायता'
    }
  ],
  faqDetailList: {
    common: [
      {
        subTitle: 'मैं पैसे जमा कैसे करूँ?',
        content:
          '<div style="margin-bottom: 10px;">अपने खाते में लॉग इन करें और निम्न चरणों को पूरा करें:</div>' +
          '<div style="margin-left: 15px;display: flex"><i>1.&nbsp;</i>जमा बटन पर क्लिक करें।</div>' +
          '<div style="margin-left: 15px;display: flex"><i>2.&nbsp;</i>जमा राशि दर्ज करें</div>' +
          '<div style="margin-left: 15px;display: flex"><i>3.&nbsp;</i> "SUBMIT"पर क्लिक करें</div>' +
          '<div style="margin-top: 10px;">फिर अपने पसंदीदा गेम खेलना शुरू करें।</div>'
      },
      {
        subTitle: 'मैं न्यूनतम कितनी राशि जमा कर सकता हूँ?',
        content: '<div>न्यूनतम जमा राशि 100 INR और अधिकतम 50,000 INR प्रति लेनदेन है।</div>'
      },
      {
        subTitle: 'मेरी जमा राशि मेरे खाते में कितनी जल्दी जमा हो जाएगी?',
        content:
          '<div>जमा प्रक्रिया तुरन्त शुरू होती है।</div>'
      },
      {
        subTitle: 'मेरी जमा राशि मेरे खाते में जमा नहीं की गई?',
        content:
          '<div>सबसे पहले अपने पेज को रिफ्रेश करना है। यदि जमा की गई राशि अभी भी क्रेडिट नहीं हुई है, तो कृपया हमारी लाइव सपोर्ट टीम से संपर्क करें, और हमारा एक प्रतिनिधि आपकी सहायता करने में सक्षम होगा।</div>' +
          '<div style="margin: 10px 0;">कृपया निम्नलिखित जानकारी प्रदान करने के लिए तैयार रहें:</div>' +
          '<div style="margin-left: 15px;display: flex"><i>1.&nbsp;</i>आपने किस जमा पद्धति का उपयोग किया?</div>' +
          '<div style="margin-left: 15px;display: flex"><i>2.&nbsp;</i>आपने जमा कब किया था?</div>' +
          '<div style="margin-left: 15px;display: flex"><i>3.&nbsp;</i>जमा राशि कितनी थी?</div>' +
          '<div style="margin-left: 15px;display: flex"><i>4.&nbsp;</i>आपका खाता किस बैंक में है?</div>' +
          '<div style="margin-left: 15px;display: flex"><i>5.&nbsp;</i>क्या उस खाते से पैसा निकाल लिया गया है जिससे आपने जमा किया था? यदि ऐसा है, तो कृपया लेन-देन/बैंक विवरण का एक स्क्रीनशॉट प्रदान करें।</div>'
      },
      {
        subTitle: 'मुझे अपने पुरानी जमा जानकारी कहां मिल सकता है?',
        content:
          '<div>इस जानकारी को देखने के लिए, केवल खाता/इतिहास बटन पर क्लिक करें। यहां आप अपनी पिछली सभी जमा राशियां देख सकते हैं।</div>'
      }
    ],
    account: [
      {
        subTitle: 'मैं एक खाता कैसे बनाऊं?',
        content:
          '<div>पंजीकरण करने और खाता बनाने के लिए, लॉग इन बटन पर क्लिक करें, अपना फ़ोन नंबर दर्ज करें और जल्दी से सरल चरणों का पालन करें।</div>'
      },
      {
        subTitle: 'मैं नया खाता बनाने में असमर्थ हूं, क्योंकि इस डिवाइस से एक खाता पहले ही बनाया जा चुका है, मैं क्या करूं?',
        content:
          '<div>सुनिश्चित करें कि आपके पास पहले से ही हमारे साथ कोई खाता नहीं है। ध्यान रखें कि हम प्रति खिलाड़ी केवल एक खाते की अनुमति देते हैं। यदि आपने पहले हमारे साथ एक खाता बनाया है, तो हम आपसे अपने मौजूदा खाते पर खेलने के लिए अनुरोध करते हैं।</div>' +
          '<div style="margin-top: 10px;">यदि आप अपना लॉगिन विवरण याद नहीं रख पा रहे हैं, तो कृपया पासवर्ड पुनर्प्राप्ति निर्देशों का पालन करें। यदि आपने कभी किसी खाते के लिए साइन अप नहीं किया है, लेकिन आपके खाते के क्रेडेंशियल पहले से ही हमारे डेटाबेस में मौजूद हैं, तो कृपया हमारी लाइव सपोर्ट टीम से संपर्क करें ताकि हम आगे की जांच कर सकें।</div>'
      },
      {
        subTitle: 'मैं अपना शेष बैलेंस कहाँ देख सकता हूँ?',
        content:
          '<div>आपको अपना बैलेंस अपनी स्क्रीन के शीर्ष पर मिलेगा।</div>'
      }
    ],
    bonus: [
      {
        subTitle: 'मैं एक नया खाता बनाने में असमर्थ हूँ, क्योंकि इस उपकरण से एक खाता पहले ही बनाया जा चुका है, मैं क्या करूँ?',
        content:
          '<div>सुनिश्चित करें कि आपके पास हमारे साथ पहले से कोई खाता नहीं है। ध्यान रखें कि हम प्रति खिलाड़ी केवल एक खाते की अनुमति देते हैं। यदि आपने अतीत में हमारे साथ एक खाता बनाया है, तो हम आपसे अपने मौजूदा खाते पर खेलने के लिए कहते हैं।`</div>'
      },
      {
        subTitle: 'मैं बोनस कैसे प्राप्त कर सकता हूँ?',
        content:
          '<div>आप नीचे "प्रचार" बटन पर क्लिक कर सकते हैं और विशिष्ट प्रचार और घटनाओं की जांच कर सकते हैं। बस शर्तें पढ़ें। </div>'
      },
      {
        subTitle: 'मैं अपने बोनस का दावा कैसे करूँ?',
        content:
          '<div>आप नीचे "प्रचार" बटन पर क्लिक कर सकते हैं और विशिष्ट प्रचार और ईवेंट की जांच कर सकते हैं। बस शर्तें पढ़ें।</div>' +
          '<div>Note: कुछ खेलों में कुछ दांव बोनस को नकद में नहीं बदल सकते। विवरण के लिए कृपया बोनस नियम देखें</div>'
      },
      {
        subTitle: 'कैश बैक बोनस क्या हैं?',
        content:
          '<div>कैशबैक बोनस एक मौद्रिक पुरस्कार है जो जमा राशि की एक निश्चित राशि का प्रतिनिधित्व करता है जिसे खेलों में डाल दिया गया है, जिसे आप अपने बटुए में बिना किसी शर्त के वापस दावा कर सकते हैं।</div>'
      },
      {
        subTitle: 'मुक्त स्पिन कैसे काम करते हैं?',
        content:
          '<div>बोनस पृष्ठ देखने के लिए आप शीर्ष पट्टी पर "बी" चिह्न पर क्लिक कर सकते हैं। बोनस इतिहास रिकॉर्ड देखने के लिए बोनस पृष्ठ पर "इतिहास" पर क्लिक करें।</div>'
      },
      {
        subTitle: 'क्या बोनस समाप्त होता है',
        content:
          '<div>बोनस सात (7) दिनों के लिए मान्य हैं, इसलिए किसी भी मौजूदा दांव की आवश्यकताओं को उस समय सीमा के भीतर पूरा किया जाना चाहिए; अन्यथा बोनस की शेष राशि रद्द कर दी जाएगी।</div>'
      }
    ],
    deposit: [
      {
        subTitle: 'मैं जमा कैसे करूँ',
        content:
          '<div style="margin-bottom: 10px;">अपने खाते में लॉग इन करें और निम्न चरणों को पूरा करें:</div>' +
          '<div style="margin-left: 15px;display: flex"><i>1.&nbsp;</i>बटन पर क्लिक करें</div>' +
          '<div style="margin-left: 15px;display: flex"><i>2.&nbsp;</i>जमा राशि दर्ज करें</div>' +
          '<div style="margin-left: 15px;display: flex"><i>3.&nbsp;</i>SUBMIT" पर क्लिक करें</div>' +
          '<div style="margin-top: 10px;">फिर अपने पसंदीदा गेम खेलना शुरू करें।</div>'
      },
      {
        subTitle: 'मैं न्यूनतम और अधिकतम कितनी राशि जमा कर सकता हूँ?',
        content: '<div>न्यूनतम जमा राशि 100 INR और अधिकतम 50,000 INR प्रति लेनदेन है।</div>'
      },
      {
        subTitle: '3डी सिक्योर कैसे काम करता है?',
        content:
          '<div>जमा करने से पहले, सिस्टम कार्डधारक को कार्ड जारी करने वाले बैंक के ब्राउज़र पर रीडायरेक्ट करके कार्डधारक को प्रमाणित करता है।</div>' +
          '<div style="margin-top: 10px;">जब आप 3डी सिक्योर के साथ ऑनलाइन लेनदेन करते हैं, तो आपको अपने कार्ड जारीकर्ता के एक वेबपेज पर पुनः निर्देशित किया जाता है, जो आपसे आपका पिन या पासवर्ड दर्ज करने के लिए कहता है।</div>'
      },
      {
        subTitle: 'मेरी जमा राशि मेरे खाते में कितनी जल्दी जमा हो जाएगी?',
        content:
          '<div>प्रसंस्करण समय तुरन्त शुरू होता है।</div>'
      },
      {
        subTitle: 'मेरी जमा राशि मेरे खाते में कितनी जल्दी जमा हो जाएगी?',
        content:
          '<div>सबसे पहले अपने पेज को रिफ्रेश करना है। यदि जमा की गई राशि अभी भी क्रेडिट नहीं हुई है, तो कृपया हमारी लाइव सपोर्ट टीम से संपर्क करें, और हमारा एक प्रतिनिधि आपकी सहायता करने में सक्षम होगा।</div>' +
          '<div style="margin: 10px 0;">कृपया निम्नलिखित जानकारी प्रदान करने के लिए तैयार रहें:</div>' +
          '<div style="margin-left: 15px;display: flex"><i>1.&nbsp;</i>आपने किस जमा तरीका का उपयोग किया?</div>' +
          '<div style="margin-left: 15px;display: flex"><i>2.&nbsp;</i>आपने कब जमा किया?</div>' +
          '<div style="margin-left: 15px;display: flex"><i>3.&nbsp;</i>कितनी राशि जमा थी?</div>' +
          '<div style="margin-left: 15px;display: flex"><i>4.&nbsp;</i>आपका खाता किस बैंक में है?</div>' +
          '<div style="margin-left: 15px;display: flex"><i>5.&nbsp;</i>क्या आपने जिस खाते से अपनी जमा राशि जमा की थी, उससे धनराशि निकाल ली गई है? यदि ऐसा है, तो कृपया लेन-देन/बैंक विवरण का एक स्क्रीनशॉट प्रदान करें.</div>'
      },
      {
        subTitle: 'मुझे अपना जमा इतिहास कहां मिल सकता है?',
        content:
          '<div>इस जानकारी को देखने के लिए, केवल खाता/इतिहास बटन पर क्लिक करें। यहां आप अपने सभी पिछले डिपॉजिट देख सकते हैं</div>'
      }
    ],
    withdraw: [
      {
        subTitle: 'क्या मैं अपना बोनस शेष निकाल सकता हूँ?',
        content:
          '<div>यदि दांव की नियम और शर्तें अभी तक पूरी नहीं हुई हैं तो बोनस शेष वापस नहीं लिया जा सकता है।</div>'
      },
      {
        subTitle: 'मैं निकासी कैसे करूँ?',
        content:
          '<div>निकासी अनुरोध करने के लिए, \'निकासी\' बटन पर क्लिक करें और चरणों का पालन करें।</div>'
      },
      {
        subTitle: 'मैं कितना राशि निकाल सकता हूँ?',
        content:
          '<div>न्यूनतम निकासी राशि 500 रुपये है। प्रति लेनदेन अधिकतम निकासी राशि 50,000 रुपये है। कितना निकाला जा सकता है इसकी कोई सीमा नहीं है।</div>'
      },
      {
        subTitle: 'मैं कब निकासी कर सकता हूं?',
        content:
          '<div>आप किसी भी समय निकासी के लिए आवेदन कर सकते हैं। निकासी की प्रक्रिया तुरंत शुरू होती है लेकिन आपके बैंक के आधार पर इसमें 24 - 48 घंटे लग सकते हैं। अधिकांश बैंकों में निकासी तुरंत और उसी दिन की जाती है।</div>'
      }
    ],
    wagering: [
      {
        subTitle: 'दांव लगाने की आवश्यकता क्या है?',
        content:
          '<div>वेजरिंग रिक्वायरमेंट, जैसा कि अक्सर कहा जाता है, वह मूल्य राशि है जिसे आपको अपने बोनस बैलेंस को वास्तविक पैसे में बदलने और निकासी के योग्य बनने के लिए दांव लगाने की आवश्यकता होती है। उदाहरण के लिए: यदि कोई खिलाड़ी 100% बोनस के साथ ₹1,000 जमा करता है और उस बोनस में 40X दांव लगाने की आवश्यकता होती है, तो इसका मतलब होगा कि आपके खाते में जमा बोनस राशि (₹1,000) को केवल परिवर्तित किया जा सकता है और आपके नकद खाते में दावा किया जा सकता है यदि आपने अपनी बोनस राशि का 40X (40 गुना) दाँव लगाया या खेला।</div>' +
          '<div style="margin-top: 10px;">₹जमा बोनस प्रचार पर ₹1,000 जमा = ₹1,000 बोनस राशि</div>' +
          '<div style="margin-top: 10px;">इस उदाहरण में, ₹1,000 बोनस राशि X 40 आपकी दांव लगाने की आवश्यकता है = ₹40,000</div>' +
          '<div style="margin-top: 10px;">एक बार जब आप अपने कैश बैलेंस के साथ ₹40,000 मूल्य की बेट लगा लेते हैं (उदाहरण के लिए प्रत्येक ₹4,000 की 10 बेट हो सकती है), तो आपकी बोनस राशि पूरी तरह से रूपांतरित हो जाएगी (प्रगति देखें) \'बी\' संतुलन)।आप अपने मुख्य नकद शेष राशि के लिए \'बी\' शेष राशि का दावा कर सकते हैं और फिर आप अपने धन को निकालने के लिए पात्र हैं।</div>' +
          '<div style="margin-top: 10px;">कृपया ध्यान दें कि आपको पूरी बोनस राशि परिवर्तित होने तक प्रतीक्षा करने की आवश्यकता नहीं है। बेट वाला प्रत्येक रुपया बोनस राशि को 40/40 की दर से परिवर्तित करेगा।</div>' +
          '<div style="margin-top: 10px;">उदाहरण के लिए:</div>' +
          '<div style="margin-top: 10px;">यदि आप अपने कैश बैलेंस के साथ ₹40 की शर्त लगाते हैं, तो आपका परिवर्तित बोनस 40/40 = ₹1 है</div>' +
          '<div style="margin-top: 10px;">कुल ₹10,000 की शर्त लगाने के बाद, आपका परिवर्तित बोनस 10,000/40 = ₹250 है</div>' +
          '<div style="margin-top: 10px;">आप शीर्ष मेनू पर \'B\' शेष राशि में अपनी बोनस परिवर्तित प्रगति देख सकते हैं। आप अपने कैश बैलेंस में किसी भी समय किसी भी \'बी\' बैलेंस राशि का दावा कर सकते हैं और निकाल सकते हैं।</div>' +
          '<div style="margin-top: 10px;">अधिक जानकारी के लिए, हमारे नियम और शर्तें पृष्ठ देखें। ध्यान दें: <i>रूपांतरित बोनस बैलेंस मोबाइल ऐप पर \'बी\' बैलेंस के रूप में दिखाया जाता है और वेबसाइट पर यह \'ट्रॉफी\' बैलेंस होता है जब आप अपने उपयोगकर्ता नाम के आगे अपने कैश बैलेंस पर होवर करते हैं।</i></div>' +
          '<div style="margin-top: 10px;">नीचे दी गई सूची में गैर-भाग लेने वाले खेलों को छोड़कर PGEBet पर सभी खेलों में 40X की दांव लगाने की आवश्यकता है:</div>' +
          '<div style="margin-top: 10px;">तीन पत्ती - जिली – Jili</div>' +
          '<div style="margin-top: 10px;">AK47 – जेली</div>' +
          '<div style="margin-top: 10px;">अंदर बाहर - जिली</div>' +
          '<div style="margin-top: 10px;">रम्मी - जिली</div>'
      }
    ],
    support: [
      {
        subTitle: 'क्या होता है यदि खेल एक दौर के बीच में रुक जाता है?',
        content:
          '<div>क्या आपका गेम किसी भी समय फ्रीज हो जाना चाहिए, अगली बार जब आप गेम खोलेंगे तो आप ठीक वहीं पर समाप्त हो जाएंगे जहां आपने छोड़ा था। यदि आपके पास ऐसा करने का कोई विकल्प नहीं है, तो सर्वर पर राउंड पूरा हो जाएगा, भले ही आपका कंप्यूटर जम गया हो या इंटरनेट कनेक्शन ने काम करना बंद कर दिया हो। किसी भी जीत का भुगतान हमेशा की तरह आपके खाते में कर दिया जाता है।</div>'
      },
      {
        subTitle: 'खेल धीमे क्यों चल रहे हैं?',
        content:
          '<div>सुनिश्चित करें कि आपके पास अपने ब्राउज़र का नवीनतम संस्करण स्थापित है (हम Google क्रोम की अनुशंसा करते हैं) और फ्लैश का नवीनतम संस्करण। यह भी सुनिश्चित करें कि यह इंटरनेट कनेक्शन नहीं है जो समस्या है (यदि वायरलेस कनेक्शन इस तरह काम नहीं कर रहा है तो नेटवर्क केबल के साथ खेलने का प्रयास करें) और किसी भी पृष्ठभूमि प्रोग्राम को बंद कर दें जो आपके बैंडविड्थ को कम कर सकता है।</div>'
      },
      {
        subTitle: 'मेरे गेम लोड क्यों नहीं हो रहे हैं?',
        content:
          '<div>इसका मतलब यह हो सकता है कि आपने सर्वर से संपर्क खो दिया है। लॉग आउट करने का प्रयास करें और वापस लॉग इन करें और पुनः प्रयास करें। कभी-कभी आपको गेम को लोड करने के लिए ब्राउज़र को बंद करने और फिर से शुरू करने की आवश्यकता हो सकती है। यदि समस्या बनी रहती है, तो कृपया हमारी लाइव सपोर्ट टीम से संपर्क करें और हमारा एक प्रतिनिधि मदद करने में सक्षम होगा।</div>'
      },
      {
        subTitle: 'यदि मैं किसी खेल की शुरुआत नहीं कर पाता हूँ तो मैं क्या करूँ?',
        content:
          '<div>गेम खोलने का प्रयास करते समय यदि आपको त्रुटि संदेश प्राप्त होता है, तो हमारी लाइव सहायता टीम से संपर्क करें और हमारा एक प्रतिनिधि आपकी सहायता कर सकेगा।</div>'
      }
    ]
  },
  aboutUs: [
    {
      class: 't1',
      content: '<span style="font-weight: bold">हमारे बारे में</span>'
    },
    {
      class: 't2',
      content: 'PGEbet का संचालन प्राइमटाइम गेमिंग एंड एंटरटेनमेंट N.V. द्वारा किया जाता है, जिसका कार्यालय Zuikertuintjeweg (Zuikertuin Tower), Willemstad, Curacao में है। कंपनी पंजीकरण संख्या 160961।'
    },
    {
      class: 't2',
      content: 'PGEBet प्राइमटाइम गेमिंग एंड एंटरटेनमेंट N.V द्वारा संचालित है, जिसका कार्यालय Zuikertuintjeweg (Zuikertuin Tower), Willemstad, Curacao में है। कंपनी रजिस्ट्रेशन नंबर 160961।'
    },
    {
      class: 't2',
      content: 'हमें भारत में सबसे भरोसेमंद और सुरक्षित ऑनलाइन कैसीनो और स्पोर्ट्स बेटिंग साइट होने के अपने लक्ष्य पर गर्व है।'
    },
    {
      class: 't1',
      content: '<span style="font-weight: bold">उचित, सुरक्षित और सुरक्षित</span>'
    },
    {
      class: 't2',
      content: 'जब आप PGEBet पर खेलते हैं, तो आप एक निष्पक्ष, सुरक्षित और सुरक्षित ऑनलाइन सट्टेबाजी के माहौल की गारंटी देते हैं।'
    },
    {
      class: 't2',
      content: 'हम साल में 365 दिन उपलब्ध हैं और हमारी ग्राहक सहायता टीम यह सुनिश्चित करने के लिए यहां है कि हमारे साथ आपका समय परेशानी मुक्त और यथासंभव सुखद हो।'
    },
    {
      class: 't2',
      content: 'तो ऑनलाइन गेमिंग और खेल सट्टेबाजी मनोरंजन में परम अनुभव की खोज करें। हमें विश्वास है कि ऑनलाइन बेट लगाने के लिए PGEBet आपकी पसंदीदा जगह होगी। हम भारत के सभी पात्र खिलाड़ियों का स्वागत करते हैं।'
    }
  ],
  kycPolicy: [
    {
      class: 't0',
      content: 'प्राइमटाइम गेमिंग एंड एंटरटेनमेंट की केवाईसी नीति एन.वी'
    },
    {
      class: 't2',
      content: 'जब कोई उपयोगकर्ता बेटअजय प्लेटफॉर्म के अंदर किसी भी राशि की पहली निकासी का अनुरोध करता है, तो उसके लिए पूर्ण केवाईसी प्रक्रिया करना अनिवार्य होता है।'
    },
    {
      class: 't2',
      content: 'इस प्रक्रिया के दौरान, उपयोगकर्ता को अपने बारे में कुछ बुनियादी जानकारी देनी होगी और फिर अपलोड करनी होगी:'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i>1)सरकार द्वारा जारी फोटो पहचान पत्र की एक प्रति (कुछ मामलों में दस्तावेज़ के आधार पर आगे और पीछे)'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i>2)आईडी डॉक पकड़े हुए खुद की एक सेल्फी'
    },
    {
      class: 't2',
      content: 'एक बार अपलोड हो जाने पर, उपयोगकर्ता को "अस्थायी रूप से स्वीकृत" स्थिति मिल जाएगी और दस्तावेज़ अब हमारे पक्ष में होंगे, और "केवाईसी टीम" के पास उन पर जाने और उपयोगकर्ता को परिणाम के बारे में ईमेल करने के लिए 24 घंटे होंगे:'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i>-अनुमति'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i>-अस्वीकार'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i>-अधिक जानकारी की आवश्यकता - स्थिति में कोई बदलाव नहीं'
    },
    {
      class: 't1',
      content: '"केवाईसी प्रक्रिया" के लिए दिशानिर्देश'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i>1)आईडी का प्रमाण'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i><i style="margin-left: 20px;"></i>a.हस्ताक्षर दिख रहा है'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i><i style="margin-left: 20px;"></i>b.देश एक प्रतिबंधित देश नहीं है: संयुक्त राज्य अमेरिका और उसके क्षेत्र, फ्रांस और उसके क्षेत्र, नीदरलैंड और उसके क्षेत्र और देश जो बोनायर, सिंट यूस्टैटियस, सबा, अरूबा, कुराकाओ और सिंट मार्टेन, ऑस्ट्रेलिया और उसके सहित नीदरलैंड के राज्य का निर्माण करते हैं। क्षेत्र, यूनाइटेड किंगडम ऑफ ग्रेट ब्रिटेन, उत्तरी आयरलैंड, स्पेन'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i><i style="margin-left: 20px;"></i>c.पूरा नाम ग्राहक के नाम से मेल खाता है.'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i><i style="margin-left: 20px;"></i>d.दस्तावेज़ अगले 3 महीनों में समाप्त नहीं होता है.'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i><i style="margin-left: 20px;"></i>e.मालिक की उम्र 18 वर्ष से अधिक है.'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i>2)निवास का प्रमाण'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i><i style="margin-left: 20px;"></i>a.आईडी को निवास का प्रमाण दिखाना होगा (अन्यथा बैंक स्टेटमेंट या यूटिलिटी बिल की आवश्यकता होगी). '
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i><i style="margin-left: 20px;"></i>b.देश एक प्रतिबंधित देश नहीं है: संयुक्त राज्य अमेरिका और उसके क्षेत्र, फ्रांस और उसके क्षेत्र, नीदरलैंड और उसके क्षेत्र और देश जो बोनायर, सिंट यूस्टैटियस, सबा, अरूबा, कुराकाओ और सिंट मार्टेन, ऑस्ट्रेलिया और उसके सहित नीदरलैंड के राज्य का निर्माण करते हैं। क्षेत्र, यूनाइटेड किंगडम ऑफ ग्रेट ब्रिटेन, उत्तरी आयरलैंड, स्पेन और साइप्रस'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i>3)आईडी के साथ सेल्फी'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i><i style="margin-left: 20px;"></i>a.धारक वही है जो उपरोक्त आईडी दस्तावेज़ में है'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i><i style="margin-left: 20px;"></i>b.आईडी दस्तावेज़ 1 के समान है)। सुनिश्चित करें कि फोटो/आईडी नंबर एक ही है।'
    },
    {
      class: 't1',
      content: '"केवाईसी प्रक्रिया" पर नोट्स”'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i>1)जब केवाईसी प्रक्रिया असफल होती है तो कारण प्रलेखित किया जाता है और सिस्टम में एक समर्थन टिकट बनाया जाता है। स्पष्टीकरण के साथ टिकट संख्या उपयोगकर्ता को वापस भेज दी जाती है।'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i>2)एक बार सभी उचित दस्तावेज हमारे कब्जे में हो जाने के बाद खाता स्वीकृत हो जाता है।'
    },
    {
      class: 't1',
      content: 'अन्य एएमएल उपाय'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i>1)यदि किसी उपयोगकर्ता ने पूर्ण केवाईसी पास नहीं किया है तो वे किसी भी राशि का अतिरिक्त जमा या निकासी नहीं कर सकते हैं'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i>2)किसी भी निकासी से पहले उपयोगकर्ता की गतिविधि और संतुलन पर एक विस्तृत एल्गोरिथम और मैन्युअल जांच होती है ताकि यह देखा जा सके कि निकाली गई राशि प्लेटफॉर्म में उचित गतिविधि का परिणाम है या नहीं।'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i>3)किसी भी परिस्थिति में कोई उपयोगकर्ता किसी दूसरे उपयोगकर्ता को सीधे फंड ट्रांसफर नहीं कर सकता है।'
    }
  ],
  userGuide: {
    homePrompt: 'हमारे सबसे लोकप्रिय गेम खेलें',
    depositPrompt: 'त्वरित जमा। विभिन्न विकल्प उपलब्ध हैं।',
    withdrawPrompt: 'किसी भी समय वापस लें।',
    supportPrompt: 'लाइव चैट सपोर्ट सुबह 9 बजे - आधी रात।',
    giftPrompt: 'अगले 24 घंटों में जमा करें और खेलने के लिए मुफ्त 1500 रुपये नकद बोनस प्राप्त करें। डिपॉजिट करने के लिए डिपॉजिट बटन पर जाएं।',
    bonusDepositPrompt1: '100 रुपये जमा करें और 150 रुपये बोनस प्राप्त करें।',
    bonusDepositPrompt2: '500 रुपये जमा करें और 750 रुपये बोनस प्राप्त करें।',
    bonusDepositPrompt3: '1000 रुपये जमा करें और 1500 रुपये बोनस प्राप्त करें।'
  },
  loadingStatus: {
    pullToLoad: 'अधिक लोड करने के लिए खींचें',
    releaseToLoad: 'अधिक लोड करने के लिए खींचो',
    loading: 'लोड हो रहा है'
  },
  home: {
    gameMaintenancePrompt: 'यह खेल वर्तमान में रखरखाव के अधीन है। यह कुछ ही पलों में वापस ऑनलाइन हो जाएगा। कृपया बाद में वापस आ जाना।',
    gameActivityOnThursday: 'एसिटी जल्द ही गुरुवार को आ रही है।',
    noGameMatchFilter: 'कोई गेम इस फ़िल्टर से मेल नहीं खाता',
    searchGamePlaceholder: 'गेम के लिए खोजें',
    balance: 'क्षमा करें, आपका क्रेडिट कम चल रहा है!',
    creditNotEnough: 'क्षमा करें, आपकी नकदी शेष कम हो रही है, कृपया जमा करें!',
    androidDownload: 'Android पर उपलब्ध है। इसे डाउनलोड करने यहाँ क्लिक करें।',
    loading: 'लोड हो रहा है',
    downLoadText: ['डाउनलोड करें और', 'पाएं']
  },
  /***
   * 2021-10-10 C007 उपहार का अब उपयोग नहीं किया जाता है, कृपया इसके बजाय जमा उपहार और दैनिक उपहार का उपयोग करें
   * **/
  gift: {
    prompt: 'अगले 24 घंटों में जमा करें और खेलने के लिए मुफ्त 1500 रुपए नकद बोनस प्राप्त करें। डिपॉजिट करने के लिए डिपॉजिट बटन पर जाएं।',
    rule1: '100 रुपये जमा करें और 150 रुपये बोनस प्राप्त करें।',
    rule2: '500 रुपये जमा करें और 750 रुपये बोनस प्राप्त करें।',
    rule3: '1000 रुपये जमा करें और 1500 रुपये बोनस प्राप्त करें।'
  },
  depositGift: {
    textExtra: 'पहले डिपॉजिट पर अतिरिक्त बोनस ऑफर',
    text24Hours: 'पंजीकरण के 24 घंटे बाद'
  },
  sevenDayGift: {
    textComeBack: 'वापस आओ',
    textEveryday: 'हर दिन फ्री कैश के लिए',
    btnDeposit: 'जमा',
    btnMoreCash: 'अधिक नकद',
    btnCollect: 'अभी लीजिए!',
    btnNextCash: 'अगला मुफ़्त कैश इन',
    // 2023-03-21 hp 修改七日签到第三日和第五日任务未完成提示语
    // watchAcademyVideoTip: 'अकादमी इंटरफ़ेस में गेम निर्देश वीडियो देखने की आवश्यकता है।',
    // notPlace500BetsYet: 'आपने अभी तक ₹500 मूल्य की बेट नहीं लगाई है (संचयी रूप से)',
    makeDeposit: 'आपको एक बार सफलतापूर्वक जमा करना होगा।',
    makeWithdrawal: 'आपको एक बार सफलतापूर्वक जमा करना होगा।',
    invitationNotClicked: 'आपके किसी भी रेफ़रल आमंत्रण लिंक पर क्लिक नहीं किया गया है।'
  },
  dailyFreeCash: {
    btnCheckIn: 'चेक इन',
    btnDeposit: 'जमा',
    btnPlay: 'खेलो',
    btnCancel: 'रद्द करें',
    singedText: 'आज साइन इन किया',
    giftReward: 'आपके बटुए में क्रेडिट किया गया',
    getExtra: 'अतिरिक्त पाने के लिए डिपॉजिट करें',
    brownFont: 'fontBrownIn',
    yellowFont: 'fontYellowIn',
    now: 'अब'
  },
  history: {
    Balance: 'संतुलन',
    Rectification: 'दोहराव',
    'Return To Zero': 'शून्य पर लौटें',
    status: 'स्थिति',
    Gift: 'उपहार',
    All: 'सभी',
    Deposit: 'जमा',
    Withdrawal: 'निकासी',
    'Withdrawal Fee': 'निकासी शुल्क',
    'awaiting approval': 'अनुमोदन की प्रतीक्षा कर रहा है',
    EventGift: 'घटना उपहार',
    PromotionReward: 'पदोन्नति का इनाम',
    Bonus: 'बक्शीश',
    Win: 'जीतना',
    Freebet: 'फ्रीबेट',
    'Freebet Win': 'फ्रीबेट जीत',
    Bet: 'बेट',
    Rollback: 'रोलबैक',
    Convert: 'कनवर्ट',
    Last7days: 'पिछले 7 दिन',
    Last15days: 'पिछले 15 दिन',
    Last30days: 'पिछले 30 दिनों में',
    done: 'पूर्ण',
    rejected: 'अस्वीकार कर दिया',
    processing: 'प्रसंस्करण'
  },
  landing1: {
    text11: 'अपना दांव लगाएं',
    text12: 'पीजीईबेट',
    text21: 'में सबसे अच्छा ऑनलाइन कैसीनो',
    text22: 'भारत',
    text31: 'अभी लॉग इन करें',
    text32: 'तुरंत ₹100',
    text33: 'उपहार',
    text41: 'तक',
    text42: '10,000x',
    text43: 'जीतना'
  },
  landing2: {
    text1: 'इनके साथ अपना दांव लगाएं',
    text2: 'PGEBet',
    text3: 'में सबसे अच्छा और सबसे लोकप्रिय ऑनलाइन कैसीनो',
    text4: 'भारत और एशिया',
    text5: 'अभी लॉग इन करें',
    text6: 'तुरंत ₹100 का उपहार',
    text7: 'और अन्य बोनस। तक',
    text8: '10,000x',
    text9: 'जीतना',
    contact: 'हमसे जुड़ें',
    PGEBet: 'PGEBet',
    forAndroid: 'PGEBet ऐप Android के लिए उपलब्ध है।'
  },
  landing4: {
    text11: 'अपना दांव लगाएं',
    text12: 'PGEBet',
    text21: 'सबसे अच्छा ऑनलाइन कैसीनो में',
    text22: 'भारत',
    text31: 'गेम खेलें',
    text32: '',
    text33: 'साझा करने के लिए',
    text41: 'साप्ताहिक',
    text42: '₹100,000',
    text43: 'टूर्नामेंट पुरस्कार'
  },
  download: {
    textYou: 'आप कमाल हो!',
    textDownload: 'खेलने के लिए ऐप डाउनलोड करें',
    textPlace: 'अपना दांव लगाएं',
    textTheBest: 'सर्वश्रेष्ठ ऑनलाइन कैसीनो',
    textCountry: 'भारत',
    textLogin: 'अभी लॉगिन करें',
    textInstant: '₹100 तुरन्त',
    textGift: 'उपहार',
    textUpto: 'तक',
    text10000x: '10,000x',
    textWinning: 'जीत'
  },
  share: {
    textCongratulation: 'बधाई हो!',
    textPlace: 'अपना दांव लगाएं',
    textTheBest: 'भारत में सर्वश्रेष्ठ ऑनलाइन कैसीनो',
    textRegisterNow: 'तुरंत ₹100 के उपहार के लिए अभी पंजीकरण करें',
    textUpto: '10,000x तक जीतें',
    btnStart: 'प्रारंभ'
  },
  versionUpdate: {
    textNewVersion: 'PGEBet का एक नया संस्करण उपलब्ध है। नवीनतम सुविधाओं का अनुभव करने के लिए आपको एपीके फ़ाइल का नवीनतम संस्करण डाउनलोड और इंस्टॉल करना होगा।',
    textPleaseUpgrade: 'कृपया इस भुगतान गेटवे का उपयोग करने में सक्षम होने के लिए PGEBet ऐप के नवीनतम संस्करण में अपग्रेड करें।',
    btnClickToDownload: 'अभी डाउनलोड करने के लिए क्लिक करें',
    textCopyLnk: 'या नीचे दिए गए लिंक को कॉपी करें और डाउनलोड करने के लिए अपने ब्राउज़र में पेस्ट करें',
    btnCopyLnk: 'लिंक की प्रतिलिपि करें'
  },
  copyRight: 'भारत: ई-30 चौथी मंजिल, सेक्टर 3, नोएडा - 201301। © 2022 PGEBet सर्वाधिकार सुरक्षित। प्राइमटाइम गेमिंग एंड एंटरटेनमेंट एनवी (कंपनी रजिस्ट्रेशन नंबर 160961',
  news: {
    readMore: 'और पढ़ें'
  },
  gameCompetition: {
    ranking: 'रैंकिंग',
    howToPlay: 'कैसे खेलें',
    rules: [
      'टूर्नामेंट दिनांक: प्रत्येक गुरुवार 0:00:00 से अगले बुधवार 23:59:59 तक।',
      'टूर्नामेंट में शामिल होने के लिए "अभी शामिल हों" पर क्लिक करें।',
      'खेल में वैध दांव स्कोर उत्पन्न करते हैं। ₹100 की शर्त लगाने पर 1 अंक मिलता है।',
      'रैंकिंग पिछले दिन के परिणाम प्रदर्शित करती है और प्रतिदिन अपडेट की जाती है।',
      'पुरस्कार टूर्नामेंट समाप्त होने के 5 दिनों के भीतर खिलाड़ियों के खातों में जमा कर दिए जाते हैं।',
      'Prizes：</br>' +
      'Rank #1 - #10:प्रत्येक खिलाड़ी के लिए ₹5,000। </br>' +
      'Rank #11 - #20:प्रत्येक खिलाड़ी के लिए ₹2,000।</br>' +
      'Rank #21 - #50:प्रत्येक खिलाड़ी के लिए ₹1,000।</br>'
    ],
    ipl: {
      iplRewardNav: 'आईपीएल 2022',
      weeklyBet: 'साप्ताहिक दांव',
      cashReward: 'नकद पुरस्कार',
      weekBet: 'साप्ताहिक दांव',
      totalBet: 'कुल दांव',
      rules: [
        'आईपीएल 2022 जोरों पर है! इस वर्ष के आईपीएल का समर्थन करने के लिए, PGEBet इस अवधि के दौरान क्रिकेट पर दांव लगाने वाले खिलाड़ियों को पुरस्कार दे रहा है।',
        'पुरस्कारों की गणना की जाती है और स्वचालित रूप से साप्ताहिक आधार पर दिया जाता है।',
        'कोई भी खिलाड़ी जिसने एक निश्चित राशि पर दांव लगाया है उसे एक निश्चित राशि का इनाम मिलेगा।',
        'कोई भी खिलाड़ी जिसने पूरी घटना अवधि में 10,000 रुपये से अधिक का दांव लगाया है और हर हफ्ते पुरस्कार प्राप्त किया है, उसे 100 रुपये का अतिरिक्त इनाम मिलेगा।'
      ]
    }
  },
  wagering: {
    title: 'बोनस',
    promptAll: 'नीचे दी गई सूची में गैर-भाग लेने वाले खेलों को छोड़कर सभी खेलों में 40X की दांव लगाने की आवश्यकता है।',
    promptFollowing: 'निम्नलिखित गेम बोनस में भाग नहीं ले रहे हैं:',
    name: 'नाम',
    provider: 'प्रदाता',
    wagering: 'दांव लगाना'
  },
  // 2022-03-10 CHP Bonus页面
  bonus: {
    expire: 'पर समाप्त करें',
    received: 'प्राप्त',
    completed: 'पूर्ण',
    claimed: 'दावा किया गया',
    unclaimed: ' लावारिस',
    noDataAvailable: 'कोई डेटा उपलब्ध नहीं'
  },
  // 2022-03-13 CHP 召回
  callback: {
    welcome: 'वापस स्वागत है!',
    loyal: 'निष्ठावान ग्राहकों का पुरस्कार समाप्त होता है',
    getitnow: 'इसे अभी प्राप्त करें!'
  },
  // 2022-03-17 CHP Bonus活动
  bonusActivity: {
    holi: {
      dailyGoal: 'दैनिक लक्ष्य',
      bet: 'शर्त',
      bonus: 'बोनस',
      introduction: 'होली के त्योहार के दौरान ₹100,000 तक का अतिरिक्त बोनस! बेटिंग के लक्ष्य को पूरा करने के तुरंत बाद अपने बोनस का दावा करें। जीतने के लिए दैनिक लक्ष्य 1,2 या 3 चुनें!',
      howDoesTitle: 'यह कैसे काम करता है?',
      howDoesItems: [
        'पदोन्नति अवधि: 18 मार्च से 24 मार्च 2022 तक।',
        'आप उपरोक्त तीन दैनिक लक्ष्यों में से एक चुन सकते हैं।',
        'वर्तमान दिन के लिए चुने गए दैनिक लक्ष्य पर सट्टेबाजी की आवश्यकता को पूरा करने के बाद, आप तदनुसार बोनस जमा कर सकते हैं।',
        'आप वर्तमान दिन के लिए केवल एक ही लक्ष्य चुन सकते हैं।',
        'दैनिक लक्ष्य हर दिन सुबह 00:00 बजे रीसेट होगा और बोनस लेने के लिए आपको अगले दिन सुबह 00:00 बजे से पहले इसे पूरा करना होगा।'
      ],
      confirmSelect: 'क्या आप कृपया अपने चयनित लक्ष्य की पुष्टि कर सकते हैं? आप बाद में अपना चयन नहीं बदल सकेंगे।',
      eventNotStart: 'ईवेंट शुरू नहीं हुआ',
      eventEnd: 'ईवेंट समाप्त हो गया है',
      hasCollectedBonus: 'आप पहले ही अपना बोनस जमा कर चुके हैं।',
      notEligible: 'आप इस कार्यक्रम में भाग लेने के योग्य नहीं हैं।',
      notCompleted: 'आपने चुना दैनिक लक्ष्य अभी पूरा नहीं हुआ है।',
      selectGoal: 'कृपया दैनिक लक्ष्य 1,2 या 3 चुनें',
      collect: 'इकट्ठा करें',
      notParticipate: 'आपने इस कार्यक्रम में भाग नहीं लिया।'
    }
  },
  // 2022-03-17 CHP MessageBox
  messageBox: {
    confirm: 'पुष्टि करें',
    ok: 'ठीक है',
    cancel: 'रद्द करें'
  },
  luckyWheel: {
    css: 'hi',
    record: 'अभिलेख',
    claimBtn: 'दावा',
    claimedBtn: 'दावा किया',
    executeBtn: 'जाना',
    taskName: {
      check_in: 'दैनिक साइन-इन',
      bet_amount: 'शर्त राशि',
      deposit_amount: 'जमा राशि',
      win_amount: 'जीत की रकम',
      bet_count: 'दांव की संख्या',
      win_count: 'जीत की संख्या',
      deposit_count: 'जमा की संख्या',
      on_line: 'ऑनलाइन मिनट',
      invite_count: 'वैध निमंत्रण'
    },
    typeList: [{key: 'all', name: 'सभी'}, {key: 'gift', name: 'नकद'}, {key: 'discount', name: 'छूट'}],
    dateList: [
      {key: 0, name: 'आज'},
      {key: 3, name: '3 दिन'},
      {key: 7, name: '7 दिन'},
      {key: 15, name: '15 दिन'},
      {key: 30, name: '30 दिन'}
    ],
    youHave: 'आपके पास',
    moreTimes: 'और मौके हैं',
    earnTimes: ['Cमौके अर्जित करने के ', 'लिए मिशन पूरा करें'],
    ComeBackTomorrow: ['कल वापस आओ'],
    oneMoreTime: 'संभावना +',
    chances: 'संभावना',
    acquired: 'अधिग्रहीत',
    execute: ['अधूरा मिशन,', 'अभी निष्पादित करें'],
    lookForOther: ['यह मिशन पूरा हो गया है.', 'कृपया दूसरों की जाँच करें'],
    cash: 'नकद',
    discount: 'छूट',
    deposit: 'जमा',
    play: 'खेल',
    continue: 'जारी रखना',
    cancel: 'रद्द करना',
    until: '',
    untilEnd: ' तक वैध',
    received: 'प्राप्त',
    use: 'उपयोग',
    used: 'इस्तेमाल किया गया',
    expire: 'खत्म हो चुका'
  },
  luckyCard: {
    ProbabilltyOfwinning: 'जीत की संभावना',
    Rewards: 'पुरस्कार',
    BUY: 'खरीदना',
    CollectNow: 'अभी लीजिए'
  },
  inviteFriends: {
    channel: 'चैनल अनुसरण करें',
    inviteMsg: 'गेम खेलने और बड़ी जीत के लिए PGEBet में मेरे साथ जुड़ें!\n' +
      '1. PGEBet ऐप डाउनलोड करने के लिए लिंक पर क्लिक करें: {shareURL}\n' +
      '2. ₹{amount1} + ₹{amount2} विशेष निःशुल्क नकद और ₹{amount3} तक प्रथम जमा बोनस प्राप्त करें।\n' +
      ' \n' +
      'रम्मी, तीन पत्ती, एविएटर, लाइव कैसीनो, क्रिकेट, स्लॉट आपके खेलने के लिए इंतजार कर रहे हैं!\n',
    Affiliate: 'संबद्ध',
    inviteFriends: 'मित्रों को आमंत्रित करें',
    lakh: 'लाख',
    whiteTitle: ['प्रत्येक आमंत्रण', 'के लिए ', ' प्राप्त करें'],
    desc: ['आपके आमंत्रित व्यक्ति जितना अधिक ', 'दांव लगाएंगे, आप उतना अधिक  कमाएंगे'],
    shareNow: 'अब साझा करें',
    shareImage: 'चित्र साझा करें',
    steps: 'कदम',
    share: 'शेयर करना',
    sentenceOne: 'अभी PGEBet से जुड़ें ',
    sentenceTwo: 'और ₹50 प्राप्त करें',
    LongPress: 'छवि को सहेजने के लिए देर तक दबाएँ',
    otherWays: 'साझा करने के अन्य तरीके',
    bannerTxtBefore: ' ने ',
    bannerTxtAfter: ' मिनट पहले एक लिंक साझा किया था',
    saveSuccess: 'एल्बम में सहेजा गया',
    save: 'अब सहेजें',
    close: 'बंद करना',
    BetRewards: 'बेट पुरस्कार',
    Lakh: 'आमंत्रित व्यक्तियों का बेट (लाख)',
    subLakh: 'उप-आमंत्रित व्यक्तियों का बेट  (लाख)',
    timeLimited: 'सीमित समय',
    FollowChannel: 'चैनल अनुसरण करें',
    ok: 'ठीक है',
    stepsList: [
      {text: 'लिंक/छवि साझा करें'},
      {text: 'आमंत्रित रेजिस्टर'},
      {text: 'आमंत्रित व्यक्ति ने जमा/शर्त पूरी कर ली है'},
      {text: 'आमंत्रित ₹20 प्राप्त करें । आप ₹50 प्राप्त करेंगे'}
    ],
    RewardsFonts: [
      {text: ['कुल', 'पुरस्कार']},
      {text: ['पुरस्कार', 'उपलब्ध']},
      {text: ['कुल', 'आमंत्रित']}
    ],
    inviteesBetRewards: 'आमंत्रित व्यक्ति पुरस्कारों पर दांव लगाते हैं',
    rewards: 'मेरे पुरस्कार',
    claim: 'अभी दावा करें',
    details: 'विवरण',
    success: 'सफलता',
    congrats: 'बधाई',
    alert1: 'इनाम का दावा किया जा चुका है। और अधिक पाने के लिए अभी बेट लगाएं!',
    alert2: 'आमंत्रित व्यक्ति BET बोनास आवेदन किया गया है।',
    alert3: 'हमसे संपर्क करें और बोनस प्राप्त करें और पैसे कमाने के तरीके जानें!',
    alert4: 'इनाम का दावा किया गया. यदि इनाम नहीं आया है तो ग्राहक सेवा से संपर्क करें',
    contact: 'हमसे संपर्क करें',
    subBet: 'आमंत्रित व्यक्ति BET',
    copy: 'कॉपी',
    add: 'अभी जोड़ें',
    valid: 'वैध निमंत्रण',
    invitations: 'निमंत्रण लंबित हैं',
    TotalTitle1: 'कुल दांव',
    TotalTitle2: 'कुल जमा',
    TotalTitle3: 'कुल छूट',
    notYet: 'अभी तक जमा नहीं किया गया',
    lastOnline: 'अंतिम ऑनलाइन ',
    InvitationDate: 'आमंत्रण तिथि ',
    bubbleTitle: 'नियम',
    bubbleContent: [
      'उपयोगकर्ता केवल रेफरल पुरस्कार प्राप्त कर सकते हैं यदि वे आमंत्रण लिंक के माध्यम से सफलतापूर्वक पंजीकरण करते हैं।',
      'इस पृष्ठ पर सभी आमंत्रण पुरस्कारों का दावा मैन्युअल रूप से किया जाना चाहिए।',
      'सभी पुरस्कार रिकॉर्ड आमंत्रण विवरण में देखे जा सकते हैं।',
      'रेफ़रल पुरस्कार किसी भी समय बदल सकते हैं, कृपया नियमों की जांच पर ध्यान दें।',
      'यदि उपयोगकर्ताओं को रेफरल पुरस्कार मिलने पर कोई धोखाधड़ी वाला व्यवहार पाया जाता है, तो प्लेटफ़ॉर्म पुरस्कार वापस ले लेगा और उल्लंघन करने वाले खाते पर प्रतिबंध लगा देगा।',
      'कपटपूर्ण व्यवहारों में शामिल हैं: निमंत्रणों को बाध्य करने के लिए नकली खातों का उपयोग करना, विपरीत सट्टेबाजी और दुर्भावनापूर्ण शिकायतें।',
      'पीजीईबेट के पास व्याख्या का अंतिम अधिकार है। अन्य शर्तों के लिए, कृपया नियम और शर्तें देखें।'
    ]
  },
  lottery: {
    winBSEReward: 'बीएसई सेंसेक्स समापन मूल्य के अंतिम अंक का अनुमान लगाएं और ग्रैंड पुरस्कार जीतें!',
    grandWinner: 'ग्रैंड विनर',
    luckyWinner: 'लकी विनर',
    prizePool: 'पुरस्कार पूल',
    confirmBet: 'बेट की पुष्टि करें',
    betsPlaced: 'दांव लगाया',
    lastPrize: 'अंतिम पुरस्कार',
    history: 'इतिहास',
    howToPlay: 'कैसे खेलें',
    pleaseSelectNumber: 'कृपया एक नंबर चुनें',
    pleaseSelectAmount: 'कृपया उस राशि का चयन करें जिस पर आप दांव लगाना चाहते हैं',
    buySuccess: 'बधाई हो, आपने सफलतापूर्वक नंबर खरीद लिया',
    buyFailed: 'क्षमा करें, कुछ गलत हो रहा है, कृपया बाद में पुनः प्रयास करें',
    checkYourAccount: 'कृपया अपना खाता जांचें, आपको फिर से लॉगिन करने की आवश्यकता हो सकती है',
    noEnoughBalance: 'कृपया सुनिश्चित करें कि आपके पास पर्याप्त बैलेंस है',
    noSellingLottery: 'क्षमा करें, अभी कोई सक्रिय लॉटरी उपलब्ध नहीं है',
    date: 'तिथि',
    bigWinner: 'बिग विनर',
    luckyUser: 'भाग्यशाली उपयोगकर्ता',
    bet: 'शर्त',
    win: 'जीत',
    close: 'बंद करें'
  },
  agent: {
    apply: 'एजेंट के रूप में आवेदन करें',
    name: 'असली नाम',
    email: 'ईमेल',
    mobileNumber: 'मोबाइल नंबर',
    smsCode: 'एसएमएस कोड',
    send: 'भेजें',
    smsCodeSentSuccess: 'SMS कोड सफलतापूर्वक भेजा गया',
    smsCodeSentTooFrequent: 'एसएमएस कोड बहुत बार भेजा गया',
    smsCodeSentFailed: 'एसएमएस कोड भेजा गया विफल',
    submit: 'जमा करना',
    applySuccess: 'आपका आवेदन प्राप्त हुआ, हम आपसे 3 कार्य दिवसों में संपर्क करेंगे',
    applyFailed: 'क्षमा करें, कृपया अपनी सबमिट की गई जानकारी जांचें या हमारे समर्थक से संपर्क करें',
    applyDuplicated: 'एजेंट बनने के लिए आपके आवेदन की समीक्षा की जा रही है। अपना आवेदन दोबारा जमा न करें',
    incorrectSMSCode: 'कृपया अपना एसएमएस कोड जांचें',
    portfolio: 'पोर्टफोलियो',
    rewards: 'पुरस्कार',
    qrCode: 'क्यूआर कोड',
    download: 'डाउनलोड',
    share: 'कॉपी',
    inviteLink: 'आमंत्रण लिंक',
    copy: 'कॉपी',
    copySuccess: 'क्लिपबोर्ड पर कॉपी किया गया',
    rewardBalance: 'बैलेंस',
    withdraw: 'वापस लेना',
    myRewards: 'मेरे पुरस्कार',
    totalRewards: 'कुल पुरस्कार',
    inviteRewards: 'इनवाइट पुरस्कार',
    depositRewards: 'जमा पुरस्कार',
    bettingRewards: 'बेटिंग रिवार्ड्स',
    emptyTips: 'कोई डेटा नहीं',
    createTime: 'क्रिएट टाइम',
    depositAmount: 'सट्टेबाजी की राशि',
    bettingAmount: 'सट्टेबाजी की राशि',
    rules: 'नियम',
    agentSystem: 'एजेंट सिस्टम',
    moreSubordinatesTips: 'विस्तृत जानकारी में देखा जा सकता है',
    welcomeMessage: 'बीटाजय में हमसे जुड़ें, यहां गेम खोलेंt: '
  },
  treasure: {
    rupee1Treasure: '₹1 खजाना',
    emptyTips: 'कोई डेटा नहीं',
    latest: 'नवीनतम',
    treasureHistory: 'इतिहास',
    myTreasure: 'मेरा खजाना',
    drawTime: 'ड्रा टाइम',
    moneyBack: 'मनी बैक',
    buy: 'खरीदा',
    bought: 'खरीदा',
    pleaseLoginMessage: 'कृपया लॉगिन करें',
    treasureDoesNotExistMessage: 'खजाना अभी बिक्री पर नहीं है',
    doesNotOnSaleMessage: 'खजाना अभी बिक्री पर नहीं है',
    tooManyErrorMessage: 'आपके द्वारा खरीदे जाने वाले टिकटों की संख्या खरीदारी की सीमा से अधिक हो गई है',
    invalidNumberMessage: 'कृपया एक संख्या दर्ज करें',
    rules: 'Rules',
    boughtSingleResultMessage: 'बधाई हो, आपको खजाना पाने के लिए एक टिकट मिल गया है!',
    boughtMultipleResultMessage: 'बधाई हो, आपको खजाना पाने के लिए टिकट मिल गया है!',
    ok: 'ठीक है',
    win: 'जीत',
    lost: 'खोया',
    winningNumber: 'विनिंग नंबर',
    myNumbers: 'मेरा नंबर(s)>',
    myNumber: 'मेरा नंबर',
    treasure: 'खजाना',
    status: 'स्थिति',
    submit: 'सबमिट करें',
    myHistory: 'मेरा इतिहास',
    saveAddressSuccess: 'आपका पता बदल गया'
  },
  confirmWin: {
    deposit: 'जमा',
    confirm: 'पुष्टि करें'
  },
  bigR: {
    rules: 'नियम',
    notBigRday: 'पदोन्नति अवधि: शुक्रवार 00:00 ~ 23:59 नई दिल्ली समय।',
    haveDepositOnce: 'क्षमा करें, आपका बड़ाआर जमा समय सीमा से बाहर है!'
  },
  complaints: {
    whatsappNotAllowedEmpty: 'क्षमा करें, WhatsApp को खाली रहने की अनुमति नहीं है!',
    lengthMustBeTen: 'क्षमा करें, व्हाट्सएप की लंबाई 10 होनी चाहिए!',
    emailNotAllowedEmpty: 'क्षमा करें, ईमेल \'खाली होने की अनुमति नहीं है!',
    contentNotAllowedEmpty: 'क्षमा करें, विवरण \'खाली होने की अनुमति नहीं है!',
    contentLenOutOfLimit: 'क्षमा करें, विवरण की लंबाई 300 वर्णों की सीमा से बाहर है!',
    onlySummitOnceWinth24h: 'क्षमा करें, शिकायत या सुझाव 24 घंटे के भीतर एक बार प्रस्तुत किया जा सकता है!',
    summitedFailed: 'क्षमा करें, समिट में असफल!',
    summitSucess: 'बीटाजय आपके सुझावों के लिए ईमानदारी से धन्यवाद!'
  },
  support: {
    service: 'सेवा',
    sevenTwentyforService: '24/7 सर्विस',
    onlineService: 'ऑनलाइन सेवा',
    gogo: 'जाना >',
    supportEmail: 'support@PGEBet.com',
    email: 'ईमेल',
    copy: 'कॉपी',
    helpNSupport: 'सहायता और समर्थन',
    FAQ: 'सबसे सामान्य प्रश्न',
    customerService: ' ग्राहक सेवा'
  },
  VIP: {
    noGifts: 'दावा करने के लिए कोई बोनस नहीं',
    getOk: 'सफलता',
    times: ' बार',
    vipBenefits: 'वीआईपी लाभ',
    myVIPBenefits: 'मेरे वीआईपी लाभ',
    currentLevel: 'वर्तमान स्तर',
    notActivated: 'अवैध',
    upgradeBenefits: 'अपग्रेड करें और पुरस्कार जीतें',
    beingHeld: ' विशेषाधिकार रखे जा रहे हैं',
    enjoyTheMost: 'अधिकतम',
    benefits: 'लाभों का आनंद लें',
    rebets: 'अपना स्तर बनाए रखने के लिए ₹',
    toRelegate: ' अधिक का दांव लगाएं',
    reachedLevel: ' अधिक का दांव लगाएं',
    relegated: 'पहले से ही स्तर बरकरार रखा',
    seeAll: 'सभी को देखें',
    levelGift: 'अपग्रेड बोनस',
    cardRebates: 'कार्ड रिबेट',
    slotsRebates: 'स्लोट रिबेट',
    fishingRebates: 'मछली पकड़ने रिबेट',
    Offers: 'विशेष प्रचार और ऑफर',
    manager: 'समर्पित खाता प्रबंधक',
    cashAvailable: 'उपलब्ध बोनस',
    cashReceived: 'बोनस का दावा किया गया',
    getItNow: 'अभी दावा करें',
    customerService: 'विशिष्ट ग्राहक सहायता से संपर्क करें',
    recordOfCollection: 'दावा इतिहास',
    hot: 'शीर्ष सिफ़ारिशें',
    currentlyAvailable: 'दावा करने के लिए उपलब्ध',
    currentRebateRate: 'कैशबैक दर',
    extraTimes1: 'आप अतिरिक्त नंबर का दावा कर सकते हैं. दैनिक निकासी की',
    extraTimes2: '',
    unavailable1: 'आपका वर्तमान वीआईपी स्तर आनंद नहीं ले सकता',
    unavailable2: '',
    birthdayReminder: 'कृपया अपने जन्म का तिथि प्रदान करें',
    go: 'जाना',
    rule: 'नियम',
    benefitsList: [
      {
        mode: 5,
        value: 'अपग्रेड बोनस',
        desc: 'हर बार अपग्रेड करने पर नकद इनाम प्राप्त करें',
        bottom: '',
        isDark: true,
        amountShow: ''
      },
      {
        mode: 5,
        value: 'कार्ड रिबेट',
        desc: 'कार्ड गेम पर कैशबैक अर्जित करें',
        bottom: '',
        isDark: true,
        amountShow: ''
      },
      {mode: 5, value: 'स्लोट रिबेट', desc: 'स्लॉट गेम पर कैशबैक कमाएँ', bottom: '', isDark: true, amountShow: ''},
      {
        mode: 5,
        value: 'मछली पकड़ने रिबेट',
        desc: 'मछली पकड़ने के खेल पर कैशबैक कमाएँ',
        bottom: '',
        isDark: true,
        amountShow: ''
      },
      {
        mode: 5,
        value: 'खेलकूद रिबेट',
        desc: 'स्पोर्ट्स गेम्स पर कैशबैक कमाएं',
        bottom: '',
        isDark: true,
        amountShow: ''
      },
      {mode: 5, value: 'लाइव रिबेट', desc: 'लाइव गेम्स पर कैशबैक कमाएं', bottom: '', isDark: true, amountShow: ''},
      {
        mode: 5,
        value: 'जन्मदिन बोनस',
        desc: 'आपके वीआईपी स्तर के आधार पर आपके जन्मदिन पर नकद पुरस्कार दिया जाता है',
        bottom: '',
        isDark: true,
        amountShow: ''
      },
      {
        mode: 5,
        value: 'साप्ताहिक इनाम',
        desc: 'आपके वीआईपी स्तर के आधार पर साप्ताहिक नकद पुरस्कार',
        bottom: '',
        isDark: true,
        amountShow: ''
      },
      {
        mode: 5,
        value: 'विशेष प्रचार और ऑफर',
        desc: 'अपने वीआईपी स्तर के आधार पर विशेष प्रचार प्रस्तावों तक पहुंचें',
        bottom: '',
        isDark: true,
        amountShow: ''
      },
      {
        mode: 5,
        value: 'समर्पित खाता प्रबंधक',
        desc: 'अपने समर्पित खाता प्रबंधक से 1v1 सेवा का आनंद लें',
        bottom: '',
        isDark: true,
        amountShow: ''
      }, // 9
      {
        mode: 5,
        value: 'निकासी की अधिक संख्या',
        desc: 'आप अतिरिक्त नंबर का दावा कर सकते हैं. दैनिक निकासी की',
        bottom: '',
        isDark: true,
        amountShow: ''
      },
      {
        mode: 5,
        value: 'प्रीमियम अवकाश उपहार',
        desc: 'अपने वीआईपी स्तर के आधार पर छुट्टियों के दौरान उपहार प्राप्त करें',
        bottom: '',
        isDark: true,
        amountShow: ''
      }
    ],
    dateList: [
      {key: 0, name: 'आज'},
      {key: 3, name: '3 दिन'},
      {key: 7, name: '7 दिन'},
      {key: 30, name: '30 दिन'}
    ],
    typeList: [
      {key: 'all', name: 'सभी'},
      {key: 'level_reward', name: 'अपग्रेड बोनस'},
      {key: 'week_reward', name: 'साप्ताहिक इनाम'},
      {key: 'game_reward', name: 'कैशबैक इनाम'}]
  },
  sportsBetting: {
    Ranking: 'श्रेणी',
    Prizes: 'पुरस्कार',
    Value: 'कीमतों',
    sportsTitle: 'दैनिक दांव',
    title: 'IPL 2024',
    match: 'मिलाएँ',
    navItems: ['दैनिक मैच की भविष्यवाणियाँ', 'अंतिम विजेता की भविष्यवाणी', 'खेल सट्टेबाजी रैंकिंग'],
    endTime: 'पूर्वानुमान अंतिम तिथि',
    championTime: 'पूर्वानुमान अंतिम तिथि',
    draw: 'चित्र बनाना',
    count: 'भविष्यवक्ताओं',
    gameDesc: 'मैच विवरण',
    otherRound: 'अन्य मिलान',
    quizClues: 'कृपया विजेता टीम चुनें',
    actualConditions: 'जमा की गई वास्तविक राशि के अधीन',
    guessNow: 'अभी भविष्यवाणी खेलें',
    myGuess: 'मेरी भविष्यवाणी चुनती है',
    team: 'टीमें',
    mayWin: 'अपेक्षित जीतें',
    attendCount: 'प्रतिभागियों',
    shareCount: 'शेयरों',
    result: 'मैच के नतीजे',
    share: 'शेयर करना',
    lastStep: 'अन्तिम चरण',
    chooseWay: 'साझा करने की विधि',
    guessSuccess: ['अंतिम चरण'],
    guessDesc1: ['अपना दांव साझा करें', 'यदि कोई आपके लिंक पर क्लिक करता है, तो हिस्सेदारी मायने रखती है।'],
    guessDesc2: ['अपना दांव साझा करें', 'यदि कोई आपके लिंक के माध्यम से पंजीकरण करता है, तो हिस्सेदारी मायने रखती है'],
    winnerTeam: 'अंतिम विजेता की भविष्यवाणी',
    betRank: 'सट्टेबाज़ी रैंकिंग',
    myPrediction: 'मेरी भविष्यवाणी चुनती है',
    notStart: 'शुरू नहीं',
    win: 'सही',
    lose: 'चुक होना',
    myRank: 'मेरी रैंकिंग',
    notInRank: 'सूची में नहीं',
    seeReward: 'इनाम देखें',
    playerName: 'उपयोगकर्ता नाम',
    betAmount: 'कुल दांव राशि',
    shareMsg: 'हे ! मैं विश्व कप विजेता पर भविष्यवाणी कर रहा हूं। मेरे साथ भाग लेने के लिए लिंक पर क्लिक करें और ₹1,000,000 जीतने का मौका पाएं!',
    rules: [
      'आयोजन की अवधि: 22 मार्च से 27 मई',
      'दैनिक मैचों की भविष्यवाणी करने के लिए: अपना लिंक साझा करें और क्लिक प्राप्त करें',
      'चैम्पियनशिप दांव के लिए: अपना लिंक साझा करें और एक वैध पंजीकरण प्राप्त करें',
      'स्पोर्ट्स बेटिंग रैंकिंग के लिए केवल स्पोर्ट्स गेम्स को ही गिना जाता है',
      'इवेंट डेटा प्रतिदिन अपडेट किया जाता है',
      'मैच के नतीजों के बाद इन-ऐप संदेशों के माध्यम से पुरस्कार भेजे गए',
      'पुरस्कारों के लिए कड़ाई से कोई एकाधिक खाते या धोखाधड़ी नहीं; इसके परिणामस्वरूप स्थायी निलंबन और जमा राशि जब्त कर ली जाएगी',
      'इवेंट नियमों पर अंतिम निर्णय PGEBet का होता है'
    ]
  },
  withdrawMsg: {
    message1: 'सफलता',
    message2: 'अमान्य राशि, सीमा से बाहर',
    message3: 'पर्याप्त निकासी योग्य नकदी नहीं',
    message4: 'कृपया अपनी आईडी सेट करें',
    message5: 'कृपया अपना बैंक खाता सेट करें',
    message6: 'आप प्रति दिन केवल {amount} तक निकासी ही जमा कर सकते हैं',
    message7: 'निकासी शुल्क शून्य है, निकासी की पुष्टि करें?',
    message8: 'निकासी शुल्क {amount} है, निकासी की पुष्टि करें?',
    message9: 'त्रुटि वापस लें',
    message10: 'आपके पास एक पैसा प्रतीक्षा है,कृपया एक नया पैसा निवेदन के लिए प्रतीक्षा करें'
  },
  diwali: {
    title: 'होली की शुभकामनाएं',
    title1: 'अभी अवकाश बोनस प्राप्त',
    title2: 'करें!',
    top1: 'दैनिक बोनस ',
    top2: 'अंतिम बोनस ',
    progress: 'उपहार पैकेज',
    btn0: 'अभी दावा करें',
    todayProgress: 'आज का उपहार पैकेज',
    allProgress: 'सभी',
    btn9: 'चूक गया',
    btn1: 'दावा किया गया',
    btn02: 'अभी तक शुरू नहीं हुआ',
    rules: 'पदोन्नति विवरण',
    msg0: 'दावा करने में असमर्थ',
    msg1: 'इवेंट प्रारंभ नहीं हुआ है',
    ruleContent: [
      '1. घटना का समय: 22 मार्च - 28 मार्च',
      '2.भाग लेने के लिए प्रतिदिन ₹2000 जमा करें। इस पेज पर अपने पुरस्कार का दावा करें',
      '3. प्रमोशन अवधि के दौरान प्रतिदिन ₹2000 जमा करें और ₹77 बोनस प्राप्त करें',
      '4.प्रमोशन अवधि के दौरान, कुल ₹50,000 जमा करने पर आपको ₹1572 का बोनस मिल सकता है।',
      '5.बोनस वापस लेने के लिए, प्रभावी सट्टेबाजी राशि प्राप्त बोनस राशि से 10 गुना या अधिक होनी चाहिए',
      '6.उपयोगकर्ता एकाधिक खातों या पहचान का उपयोग नहीं कर सकता। किसी भी धोखाधड़ी के प्रयास के परिणामस्वरूप खाता निलंबित कर दिया जाएगा और जमा/शेष राशि की हानि होगी',
      '7.PGEBet इस प्रमोशन के लिए अंतिम व्याख्या का अधिकार सुरक्षित रखता है'
    ]
  },
  cashback: {
    route: '　कैश बैक',
    title: 'एक विशेष कैशबैक प्रमोशन, जिसे सावधानीपूर्वक केवल आपके लिए तैयार किया गया है।',
    tr1: 'उपलब्ध इनाम',
    tr2: '　प्रगति पर',
    cardBtn: 'अभी प्राप्त करें',
    cardBtn1: 'विवरण'
  },
  taskSign: {
    login: '{Amount} दिन लॉगिन',
    download_app: 'ऐप डाउनलोड करें और उपयोग करें',
    deposit: 'वापस लें ≥ ₹{Amount}',
    withdrawal: 'वापस लें ≥ ₹{Amount}',
    add_bank_account: 'निकासी पर बैंक खाता भरें',
    share: 'प्रभावी ढंग से साझा करें',
    rule: '*{Amount} दिनों के भीतर कार्य पूरा करें और बोनस प्राप्त करें।',
    remain: ' दिन शेष हैं!',
    task: 'कार्य'
  },
  anniversary: {
    event: 'आयोजन',
    shareWords: 'PGEbet 5वीं  वर्षगांठ!प्रोत्साहित करना! अपने ₹111+20 उपहार का दावा करने के लिए लिंक पर क्लिक करें! #PGEbet ',
    sentence1: '1. इसे फेसबुक पर साझा करें: <span style="color: #FFFFFF;text-decoration: underline">PGEbet 5वीं<br>  वर्षगांठ!प्रोत्साहित करना! अपने ₹111+20 उपहार का दावा करने के लिए लिंक पर क्लिक करें! #PGEbet<br><a style="color: inherit;" href="{link}">{link}</a></span>',
    sentence2: '2. दोस्तों इस लिंक के माध्यम से<br>रजिस्टर करें',
    sentence3: '3. ₹11 का दावा करें',
    word4Event2: ['<span style="color: #FFD600;">इवेंट 1 में पोस्ट के लिए 30 लाइक प्राप्त करें।</span><br> (यानी, टेक्स्ट में "पीजीई 5वीं वर्षगांठ" और "#पीजीईबेट" के साथ फेसबुक पोस्ट)<br>', '<br>अनुमोदन पर <span style="color: #FFD600;">₹111</span> का दावा करने के लिए हमारे फेसबुक फैन पेज एडमिनिस्ट्रेटर को संदेश भेजें।'],
    word4Event3: ['हमारे फेसबुक फैन पेज को फॉलो करें <span style="color: #FFFFFF;">और</span> आधिकारिक 5वीं वर्षगांठ कार्यक्रम पोस्ट को लाइक करें।<br>', '<span style="color: #FFFFFF;">व्यवस्थापक रहस्यमय नकद पुरस्कार देने के लिए प्रति सोमवार यादृच्छिक रूप से भाग्यशाली उपयोगकर्ताओं का चयन करेगा।</span>'],
    bottomWord: 'इस आलेख को पढ़ने के लिए धन्यवाद<br>' +
      'आपका ध्यान और विस्तार पर ध्यान देना एक सफल दांव लगाने वाले के गुण हैं<br>' +
      'कृपया मेरी हार्दिक शुभकामनाएं स्वीकार करें<br>' +
      'शुभकामनाएं',
    copyTextArr: ['5वीं वर्षगांठ मुबारक हो, PGEbet!   🎉 उत्सव में शामिल हों और अपने विशेष ₹111+20 उपहार का दावा करें! #PGEbet ',
      'हमारे साथ PGEbet की 5वीं वर्षगांठ मनाएं! 🎉🥂 अपने विशेष ₹111+20 उपहार का दावा करने के लिए अभी क्लिक करें! #PGEbet ',
      'PGEbet की पाँचवीं वर्षगाँठ की शुभकामनाएँ! 🌟🎊 111+20 रुपये के अपने विशेष उपहार का दावा करने के लिए लिंक पर क्लिक करें। #PGEbet ',
      '5वीं वर्षगांठ की शुभकामनाएं, PGEbet परिवार! 🎊🎁अपने ₹111+20 विशेष उपहार का दावा करने के लिए लिंक पर क्लिक करें। #PGEbet ',
      'PGEbet के साथ जश्न मनाएं! 🎉🌟अपना ₹111+20 का उपहार न चूकें - 5वीं वर्षगांठ समारोह के लिए लिंक पर क्लिक करें! #PGEbet '
    ]
  },
  welcome: {
    title: 'PGEBet में आपका स्वागत है!',
    message: 'प्रिय उपयोगकर्ता,\n' +
      '\n' +
      'PGEBet में आपका हार्दिक स्वागत है!\n' +
      'अपने मुफ्त कैश का दावा करें, खेलें और कमाई शुरू करें!\n' +
      'हम आपको यहां सभी महत्वपूर्ण संदेश भेजेंगे।\n' +
      'शुभकामनाएं,\n' +
      'PGEBet टीम'
  },
  signal: {
    bookmark: 'हमें बुकमार्क करें',
    apk: 'एपीके',
    extra1: 'अतिरिक्त रु.',
    extra2: ' बोनस!',
    link: 'जोड़ना',
    line: 'रेखा',
    follow: 'आपका पालन'
  }
}



// WEBPACK FOOTER //
// ./src/assets/locale/hi-IN.js